import React, { createContext, useState, useEffect, useRef, useCallback, useContext, useMemo, Fragment, forwardRef, cloneElement } from 'react';
import classNames from 'classnames';
import camelcase from 'camelcase';
import { useSwipeable } from 'react-swipeable';
import { Row, Col, UncontrolledTooltip, Input as Input$1, Accordion, AccordionItem, AccordionHeader, AccordionBody, Container, Label as Label$1, Collapse, Modal as Modal$1, ModalHeader, ModalBody, ModalFooter, Fade } from 'reactstrap';
import { countries } from 'country-flags-svg-v2';
import ReactDOM from 'react-dom';

const ThemeContext = createContext("white");

const circlePath = "M12 24C5.38322 24 0 18.6168 0 12C0 5.38322 5.38322 0 12 0C18.6168 0 24 5.38322 24 12C24 18.6168 18.6168 24 12 24ZM12 1.77394C6.36161 1.77394 1.77394 6.36161 1.77394 12C1.77394 17.6384 6.36161 22.2261 12 22.2261C17.6384 22.2261 22.2261 17.6384 22.2261 12C22.2261 6.36161 17.6384 1.77394 12 1.77394Z";
const icons = {
    cogwheel: {
        viewBox: "0 0 88 89",
        paths: [
            "M17.6 32.5912L15.1415 32.42C14.3754 32.3646 13.6093 32.2537 12.8633 32.0926C12.1172 31.9314 11.3762 31.7098 10.6551 31.4429L8.34686 30.5816L8.73741 25.7365C8.35687 25.4293 7.99636 25.1019 7.66088 24.7494L2.90413 25.6106L1.82259 23.3895C1.14663 21.9994 0.670953 20.5187 0.41559 18.9977L0 16.555L4.37622 14.4699C4.41127 14.2281 4.45633 13.9864 4.5064 13.7496C4.55647 13.5079 4.61656 13.2712 4.68165 13.0395L1.5522 9.32256L2.93417 7.26767C3.79539 5.98336 4.83186 4.83504 6.01855 3.84789L7.91625 2.27146L11.8919 5.0365C12.3425 4.86022 12.8082 4.70913 13.2789 4.58825L14.9162 0L17.3747 0.171241C18.1408 0.226643 18.9069 0.332409 19.6529 0.498614C20.399 0.659782 21.14 0.881388 21.8611 1.14832L24.1693 2.00956L23.7788 6.85971C24.1593 7.16694 24.5198 7.49431 24.8553 7.84687L29.6121 6.98563L30.6936 9.20672C31.3696 10.5968 31.8452 12.0775 32.1006 13.6036L32.5112 16.0463L28.14 18.1314C28.1049 18.3732 28.0599 18.6149 28.0098 18.8516C27.9597 19.0934 27.8996 19.3301 27.8345 19.5618L30.959 23.2787L29.582 25.3336C28.7208 26.6179 27.6843 27.7662 26.4976 28.7534L24.5999 30.3298L20.6243 27.5648C20.1737 27.741 19.708 27.8921 19.2373 28.013L17.6 32.5912ZM10.7953 18.0458L11.6666 19.3653C12.1723 20.1259 12.8583 20.7554 13.6594 21.1886L15.0414 21.9289L16.6036 21.8282C17.5099 21.7678 18.3961 21.4807 19.1722 20.9972L20.5041 20.1611L21.1951 18.7559C21.3954 18.348 21.5456 17.9098 21.6457 17.4615C21.7409 17.0133 21.7809 16.555 21.7659 16.0967L21.7158 14.5303L20.8446 13.2158C20.3389 12.4502 19.6479 11.8207 18.8468 11.3926L17.4648 10.6522L15.9076 10.7529C15.0013 10.8134 14.1151 11.1004 13.344 11.584L12.0071 12.425L11.3211 13.8252C11.1208 14.2332 10.9706 14.6713 10.8704 15.1196C10.7753 15.5678 10.7302 16.0261 10.7453 16.4845L10.7953 18.0458Z",
            "M16.2576 27.998C9.84351 27.998 4.62109 22.75 4.62109 16.2932C4.62109 9.83641 9.83851 4.58838 16.2576 4.58838C22.6767 4.58838 27.8942 9.83641 27.8942 16.2932C27.8942 22.75 22.6767 27.998 16.2576 27.998ZM16.2576 11.1358C13.4286 11.1358 11.1303 13.4476 11.1303 16.2932C11.1303 19.1388 13.4286 21.4506 16.2576 21.4506C19.0866 21.4506 21.3849 19.1388 21.3849 16.2932C21.3849 13.4476 19.0866 11.1358 16.2576 11.1358Z",
            "M51.6739 66.1392C49.1403 66.1392 46.6517 65.424 44.4536 64.0339C41.3792 62.0848 39.2412 59.0528 38.435 55.487C37.6289 51.9212 38.2498 48.2546 40.1875 45.1622C42.1253 42.0698 45.1396 39.9192 48.6846 39.1083C52.2296 38.2974 55.8748 38.922 58.9492 40.8711C62.0236 42.8202 64.1616 45.8522 64.9677 49.418C65.7739 52.9839 65.153 56.6504 63.2152 59.7428C61.2775 62.8353 58.2632 64.9858 54.7182 65.7967C53.7067 66.0284 52.6853 66.1442 51.6739 66.1442V66.1392ZM51.7139 45.3082C51.1882 45.3082 50.6524 45.3687 50.1267 45.4895C48.279 45.9126 46.7068 47.0358 45.6954 48.6474C44.6839 50.2591 44.3635 52.173 44.7841 54.0315C45.2047 55.8899 46.3212 57.4714 47.9235 58.4888C49.5258 59.5061 51.4285 59.8285 53.2761 59.4054C55.1238 58.9823 56.696 57.8592 57.7074 56.2475C58.7189 54.6358 59.0393 52.722 58.6187 50.8635C58.1981 49.005 57.0815 47.4236 55.4793 46.4062C54.3326 45.6809 53.0358 45.3082 51.7139 45.3082Z",
            "M51.8741 88.9998L48.1539 79.9542C45.0294 79.5462 41.9851 78.5943 39.1811 77.1539L30.9995 82.5027L29.1619 81.0119C26.2728 78.6649 23.7392 75.9149 21.6212 72.8427L20.2643 70.8734L26.2327 63.1071C25.6319 61.6516 25.1562 60.1456 24.8057 58.5994C24.4552 57.0583 24.2399 55.4919 24.1548 53.9155L15.4023 49.5237L15.7779 47.1515C16.3637 43.4597 17.4653 39.8788 19.0625 36.5043L20.074 34.3638L29.7778 35.6179C31.6855 33.1047 34.0188 30.9239 36.6525 29.1964L36.0216 19.0226L38.2498 18.1614C39.9823 17.4915 41.7648 16.9476 43.5623 16.5346C45.3599 16.1216 47.2075 15.8396 49.0551 15.6885L51.4385 15.4971L55.2439 24.9405C58.3584 25.3535 61.3977 26.3004 64.2067 27.7408L72.4233 22.4172L74.2509 23.903C77.145 26.255 79.6786 29.005 81.7866 32.0772L83.1436 34.0566L77.135 41.7977C77.7359 43.2532 78.2116 44.7591 78.5621 46.2953C78.9076 47.8314 79.1279 49.3977 79.213 50.9691L87.9855 55.3257L87.6099 57.7029C87.0291 61.3897 85.9275 64.9756 84.3303 68.3501L83.3188 70.4856L73.595 69.2667C71.6773 71.79 69.344 73.9759 66.7052 75.7034L67.241 85.4742L65.0278 86.3304C63.3004 87.0003 61.5078 87.5442 59.7103 87.9572C57.9127 88.3702 56.0701 88.6522 54.2225 88.8033L51.8591 88.9947L51.8741 88.9998ZM39.0009 69.4682L40.7483 70.541C43.7126 72.3592 47.1174 73.4219 50.5873 73.6082L52.6352 73.719L56.0401 82.0041C56.7961 81.8882 57.5422 81.7422 58.2833 81.576C59.0243 81.4047 59.7604 81.2083 60.4914 80.9867L60.0007 72.0318L61.8033 71.0396C64.8426 69.3675 67.4563 66.9298 69.354 63.9935L70.4656 62.2761L79.3932 63.3942C79.944 61.9689 80.3947 60.5083 80.7452 59.0225L72.7088 55.0336L72.7538 52.9485C72.7939 51.2059 72.6186 49.4582 72.2281 47.7508C71.8425 46.0434 71.2467 44.3915 70.4656 42.8352L69.5292 40.9818L75.0321 33.8954C74.0807 32.7068 73.0442 31.5837 71.9326 30.5411L64.3919 35.4265L62.6495 34.3588C59.6752 32.5356 56.2704 31.4728 52.8105 31.2915L50.7425 31.1807L47.2426 22.4978C46.4915 22.6136 45.7505 22.7547 45.0144 22.9259C44.2834 23.0921 43.5523 23.2885 42.8263 23.5101L43.4071 32.8579L41.5945 33.8551C38.5452 35.5323 35.9365 37.9699 34.0438 40.9012L32.9272 42.6287L24.0196 41.4753C23.4688 42.9007 23.0182 44.3613 22.6677 45.8521L30.679 49.8762L30.634 51.9513C30.5939 53.6939 30.7692 55.4416 31.1597 57.1489C31.5453 58.8563 32.1411 60.5083 32.9222 62.0646L33.8936 63.9885L32.4966 65.6707L28.3858 71.0194C29.3421 72.2131 30.3786 73.3362 31.4902 74.3788L39.0009 69.4732V69.4682Z",
        ],
    },
    handshake: {
        viewBox: "0 0 89 78",
        paths: [
            "M44.7888 77.9998L10.8486 44.2554L36.9828 18.2721L56.0654 37.2495L51.4431 41.8451L36.9828 27.4683L20.0932 44.2554L44.7888 68.8086L79.7551 34.0441L55.0594 9.49098L46.7806 17.722L42.1583 13.1264L55.0594 0.299805L88.9996 34.0441L44.7888 77.9998Z",
            "M10.8691 44.2757L0 33.4693L33.6636 0L63.575 29.7338L51.4183 41.8204L32.3508 22.8629L36.9731 18.2673L51.4183 32.6242L54.3255 29.7338L33.6636 9.19118L9.24453 33.4693L15.4914 39.6801L10.8691 44.2757Z",
            "M42.6627 42.0988L27.9814 56.6953L32.6049 61.2921L47.2861 46.6955L42.6627 42.0988Z",
            "M50.3894 49.7799L35.7081 64.3765L40.3316 68.9732L55.0129 54.3767L50.3894 49.7799Z",
            "M34.9374 34.4215L20.2561 49.0181L24.8796 53.6149L39.5609 39.0183L34.9374 34.4215Z",
        ],
    },
    notePad: {
        viewBox: "0 0 91 88",
        paths: [
            "M52.8679 43.8232H18.466V50.4233H52.8679V43.8232Z",
            "M52.8679 62.5933H18.466V69.1933H52.8679V62.5933Z",
            "M70.7421 87.7596H0.315216V0.521973H46.8006L70.737 24.7848V87.7596H70.7421ZM6.97134 81.1595H64.086V27.4756L44.005 7.12204H6.97134V81.1595Z",
            "M67.2704 28.4552H42.4329V3.82178L67.2704 28.4552Z",
            "M82.3593 87.8307L74.0493 79.0526V17.144H90.6692V79.0577L82.3593 87.8358V87.8307ZM80.7055 76.4431L82.3593 78.1896L84.0131 76.4431V23.7441H80.7055V76.4431Z",
            "M90.6692 0.521973H74.0493V12.2853H90.6692V0.521973Z",
        ],
    },
    closeCircleFill: {
        viewBox: "0 0 24 24",
        path: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z",
    },
    subtractCircle: {
        viewBox: "0 0 24 24",
        paths: [
            circlePath,
            "M15.5534 11.1758H8.44678V12.9497H15.5534V11.1758Z",
        ],
    },
    arrowDownCircle: {
        viewBox: "0 0 24 24",
        paths: [
            circlePath,
            "M12.887 7.49688H11.113V14.6036H12.887V7.49688Z",
            "M15.159 10.7924L12 13.95L8.84107 10.7924L7.58704 12.0465L12 16.4595L16.4131 12.0465L15.159 10.7924Z",
        ],
    },
    arrowUpCircle: {
        viewBox: "0 0 24 24",
        paths: [
            circlePath,
            "M12.887 9.39642H11.113V16.5031H12.887V9.39642Z",
            "M15.159 13.2076L12 10.05L8.84107 13.2076L7.58704 11.9535L12 7.54053L16.4131 11.9535L15.159 13.2076Z",
        ],
    },
    arrowUp: {
        viewBox: "0 0 24 24",
        path: "M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z",
    },
    arrowDown: {
        viewBox: "0 0 24 24",
        path: "M13 16.172V4h-2v12.172l-5.364-5.364-1.414 1.414L12 20l7.778-7.778-1.414-1.414L13 16.172z",
    },
    twitter: {
        viewBox: "0 0 24 24",
        path: "M15.3 5.55a2.9 2.9 0 0 0-2.9 2.847l-.028 1.575a.6.6 0 0 1-.68.583l-1.561-.212c-2.054-.28-4.022-1.226-5.91-2.799-.598 3.31.57 5.603 3.383 7.372l1.747 1.098a.6.6 0 0 1 .034.993L7.793 18.17c.947.059 1.846.017 2.592-.131 4.718-.942 7.855-4.492 7.855-10.348 0-.478-1.012-2.141-2.94-2.141zm-4.9 2.81a4.9 4.9 0 0 1 8.385-3.355c.711-.005 1.316.175 2.669-.645-.335 1.64-.5 2.352-1.214 3.331 0 7.642-4.697 11.358-9.463 12.309-3.268.652-8.02-.419-9.382-1.841.694-.054 3.514-.357 5.144-1.55C5.16 15.7-.329 12.47 3.278 3.786c1.693 1.977 3.41 3.323 5.15 4.037 1.158.475 1.442.465 1.973.538z",
    },
    chat: {
        viewBox: "0 0 24 24",
        path: "M5.763 17H20V5H4v13.385L5.763 17zm.692 2L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455z",
    },
    linkedin: {
        viewBox: "0 0 24 24",
        path: "M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v14h14V5H5zm2.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-1 1h2v7.5h-2V10zm5.5.43c.584-.565 1.266-.93 2-.93 2.071 0 3.5 1.679 3.5 3.75v4.25h-2v-4.25a1.75 1.75 0 0 0-3.5 0v4.25h-2V10h2v.43z",
    },
    mic: {
        viewBox: "0 0 24 24",
        path: "M12 3a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zm0-2a5 5 0 0 1 5 5v4a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5zM3.055 11H5.07a7.002 7.002 0 0 0 13.858 0h2.016A9.004 9.004 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.055 11z",
    },
    arrow: {
        viewBox: "0 0 24 24",
        path: "M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z",
    },
    arrowLeft: {
        viewBox: "0 0 24 24",
        path: "M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z",
    },
    chevron: {
        viewBox: "0 0 24 24",
        path: "M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z",
    },
    article: {
        viewBox: "0 0 24 24",
        path: "M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1zm-1-2V4H5v16h14zM7 6h4v4H7V6zm0 6h10v2H7v-2zm0 4h10v2H7v-2zm6-9h4v2h-4V7z",
    },
    at: {
        viewBox: "0 0 24 24",
        path: "M20 12a8 8 0 1 0-3.562 6.657l1.11 1.664A9.953 9.953 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v1.5a3.5 3.5 0 0 1-6.396 1.966A5 5 0 1 1 15 8H17v5.5a1.5 1.5 0 0 0 3 0V12zm-8-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
    },
    user: {
        viewBox: "0 0 24 24",
        path: "M4 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H4zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z",
    },
    time: {
        viewBox: "0 0 24 24",
        path: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z",
    },
    team: {
        viewBox: "0 0 24 24",
        path: "M12 11a5 5 0 0 1 5 5v6h-2v-6a3 3 0 0 0-2.824-2.995L12 13a3 3 0 0 0-2.995 2.824L9 16v6H7v-6a5 5 0 0 1 5-5zm-6.5 3c.279 0 .55.033.81.094a5.947 5.947 0 0 0-.301 1.575L6 16v.086a1.492 1.492 0 0 0-.356-.08L5.5 16a1.5 1.5 0 0 0-1.493 1.356L4 17.5V22H2v-4.5A3.5 3.5 0 0 1 5.5 14zm13 0a3.5 3.5 0 0 1 3.5 3.5V22h-2v-4.5a1.5 1.5 0 0 0-1.356-1.493L18.5 16c-.175 0-.343.03-.5.085V16c0-.666-.108-1.306-.309-1.904.259-.063.53-.096.809-.096zm-13-6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm13 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm-13 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm13 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM12 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
    },
    seedling: {
        viewBox: "0 0 24 24",
        path: "M6 3c3.49 0 6.383 2.554 6.913 5.895C14.088 7.724 15.71 7 17.5 7H22v2.5c0 3.59-2.91 6.5-6.5 6.5H13v5h-2v-8H9c-3.866 0-7-3.134-7-7V3h4zm14 6h-2.5c-2.485 0-4.5 2.015-4.5 4.5v.5h2.5c2.485 0 4.5-2.015 4.5-4.5V9zM6 5H4v1c0 2.761 2.239 5 5 5h2v-1c0-2.761-2.239-5-5-5z",
    },
    question: {
        viewBox: "0 0 24 24",
        path: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355z",
    },
    play: {
        viewBox: "0 0 24 24",
        path: "M16.394 12L10 7.737v8.526L16.394 12zm2.982.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z",
    },
    phone: {
        viewBox: "0 0 24 24",
        path: "M9.366 10.682a10.556 10.556 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296 11.422 11.422 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995c-.53.055-1.064.082-1.602.082C9.94 21 3 14.06 3 5.5c0-.538.027-1.072.082-1.602A1 1 0 0 1 4.077 3h4.462a1 1 0 0 1 .997.921A11.422 11.422 0 0 0 10.9 8.504a1 1 0 0 1-.296 1.294l-1.238.884zm-2.522-.657l1.9-1.357A13.41 13.41 0 0 1 7.647 5H5.01c-.006.166-.009.333-.009.5C5 12.956 11.044 19 18.5 19c.167 0 .334-.003.5-.01v-2.637a13.41 13.41 0 0 1-3.668-1.097l-1.357 1.9a12.442 12.442 0 0 1-1.588-.75l-.058-.033a12.556 12.556 0 0 1-4.702-4.702l-.033-.058a12.442 12.442 0 0 1-.75-1.588z",
    },
    mapPin: {
        viewBox: "0 0 24 24",
        path: "M12 20.9l4.95-4.95a7 7 0 1 0-9.9 0L12 20.9zm0 2.828l-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728zM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8z",
    },
    mail: {
        viewBox: "0 0 24 24",
        path: "M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z",
    },
    login: {
        viewBox: "0 0 24 24",
        path: "M4 15h2v5h12V4H6v5H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6zm6-4V8l5 4-5 4v-3H2v-2h8z",
    },
    listUnorderd: {
        viewBox: "0 0 24 24",
        path: "M8 4h13v2H8V4zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z",
    },
    info: {
        viewBox: "0 0 24 24",
        path: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z",
    },
    home: {
        viewBox: "0 0 24 24",
        path: "M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.49a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79V20zm-2-1V9.978l-7-5.444-7 5.444V19h14z",
    },
    global: {
        viewBox: "0 0 24 24",
        path: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z",
    },
    file: {
        viewBox: "0 0 24 24",
        path: "M21 8v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8zm-2 1h-5V4H5v16h14V9zM8 7h3v2H8V7zm0 4h8v2H8v-2zm0 4h8v2H8v-2z",
    },
    fileList: {
        viewBox: "0 0 24 24",
        path: "M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12h4v4a3 3 0 0 1-3 3zm-1-5v2a1 1 0 0 0 2 0v-2h-2zm-2 3V4H4v15a1 1 0 0 0 1 1h11zM6 7h8v2H6V7zm0 4h8v2H6v-2zm0 4h5v2H6v-2z",
    },
    fileDownload: {
        viewBox: "0 0 24 24",
        path: "M13 12h3l-4 4-4-4h3V8h2v4zm2-8H5v16h14V8h-4V4zM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992z",
    },
    error: {
        viewBox: "0 0 24 24",
        path: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z",
    },
    download: {
        viewBox: "0 0 24 24",
        path: "M3 19h18v2H3v-2zM13 9h7l-8 8-8-8h7V1h2v8z",
    },
    checkbox: {
        viewBox: "0 0 24 24",
        path: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z",
    },
    calendar: {
        viewBox: "0 0 24 24",
        path: "M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm3 6V5h-3v2h-2V5H9v2H7V5H4v4h16zm0 2H4v8h16v-8zM6 13h5v4H6v-4z",
    },
    calendarEmpty: {
        viewBox: "0 0 24 24",
        path: "M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm-2 2H9v2H7V5H4v4h16V5h-3v2h-2V5zm5 6H4v8h16v-8z",
    },
    close: {
        viewBox: "0 0 24 24",
        path: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z",
    },
    link: {
        viewBox: "0 0 24 24",
        path: "M18.364 15.536L16.95 14.12l1.414-1.414a5 5 0 1 0-7.071-7.071L9.879 7.05 8.464 5.636 9.88 4.222a7 7 0 0 1 9.9 9.9l-1.415 1.414zm-2.828 2.828l-1.415 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 1 0 7.071 7.071l1.414-1.414 1.415 1.414zm-.708-10.607l1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07z",
    },
    check: {
        viewBox: "0 0 24 24",
        path: "M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z",
    },
    search: {
        viewBox: "0 0 24 24",
        path: "M18.1586,18.0219 C18.1362,18.2444 18.0289,18.4438 17.8582,18.5832 L17.7589,18.6643 C17.6313,18.7685 17.477,18.8315 17.3121,18.8468 C17.034,18.8726 16.7627,18.7601 16.5885,18.5461 L14.6046,16.1171 C15.1204,15.8074 15.5885,15.4264 15.9964,14.9886 L17.9766,17.4125 C18.116,17.5835 18.1807,17.8 18.1586,18.0219 M5.80783,10.6392 C5.80783,7.59602 8.28378,5.12016 11.3268,5.12016 C14.3701,5.12016 16.8458,7.59602 16.8458,10.6392 C16.8458,13.6825 14.3701,16.1584 11.3268,16.1584 C8.28378,16.1584 5.80783,13.6825 5.80783,10.6392 M18.6698,16.8454 L16.5714,14.276 C17.2898,13.2433 17.7126,11.9899 17.7126,10.6392 C17.7126,7.11816 14.848,4.25346 11.3268,4.25346 C7.80572,4.25346 4.94112,7.11816 4.94112,10.6392 C4.94112,14.1604 7.80572,17.0251 11.3268,17.0251 C12.198,17.0251 13.0287,16.849 13.7861,16.5319 L15.8941,19.1131 C16.2578,19.5582 16.8188,19.7924 17.3944,19.7391 C17.7378,19.7076 18.0594,19.5756 18.3263,19.358 L18.4254,19.2773 C18.7819,18.9861 19.0035,18.5722 19.0499,18.1122 C19.0963,17.6518 18.9614,17.2019 18.6698,16.8454 Z",
    },
    searchSimple: {
        viewBox: "0 0 24 24",
        path: "M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z",
    },
    quote: {
        viewBox: "0 0 67 54",
        path: "M38.3108614,53 L41.8838951,31.164794 L55.9775281,0 L66.6966292,0 L55.1835206,29.576779 L65.1086142,29.576779 L61.5355805,53 L38.3108614,53 Z M0,53 L3.57303371,31.164794 L17.6666667,0 L28.5842697,0 L17.071161,29.576779 L26.7977528,29.576779 L23.2247191,53 L0,53 Z",
    },
};

var style$1c = {"icon":"style-module_icon__qdRso","white":"style-module_white__KG5Wj","darkGrey":"style-module_darkGrey__q-Y-5","primary":"style-module_primary__M5XKa","midGrey":"style-module_midGrey__apFe5","lightGrey":"style-module_lightGrey__7xJHP","lightMidGrey":"style-module_lightMidGrey__Kd4rC","primaryGreen":"style-module_primaryGreen__zo8nz","sustainableGreen":"style-module_sustainableGreen__8u-IB","fundamentalGreen":"style-module_fundamentalGreen__a-b01","multiBlue":"style-module_multiBlue__0TJ8k","fixedBlue":"style-module_fixedBlue__GKpp9","quantitativeRed":"style-module_quantitativeRed__5dPXE","trustedBlue":"style-module_trustedBlue__KuzHP","error":"style-module_error__-OTnB","main":"style-module_main__RSlBu"};

const Icon = ({ name = "article", color = "primary", size = 20, className, id, font, }) => {
    var _a;
    const theme = React.useContext(ThemeContext);
    const icon = icons[name];
    const sizeRem = size / 16;
    const sizeStyle = { width: `${sizeRem}rem`, height: `${sizeRem}rem` };
    color = theme === "primary" ? "white" : color;
    if (font) {
        return (React.createElement("div", { className: classNames(style$1c.icon, className, style$1c[color], `icon-${font}`), id: id, style: { fontSize: `${sizeRem}rem` } }));
    }
    return (React.createElement("svg", { "aria-hidden": true, className: classNames(style$1c.icon, className, style$1c[color]), id: id, preserveAspectRatio: "xMinYMin", style: sizeStyle, viewBox: icon.viewBox, xmlns: "http://www.w3.org/2000/svg" },
        icon.path && React.createElement("path", { d: icon.path }),
        ((_a = icon.paths) === null || _a === void 0 ? void 0 : _a.length) &&
            icon.paths.map((path, id) => React.createElement("path", { d: path, key: id }))));
};

var style$1b = {"callToAction":"style-module_callToAction__sAdwb","icon":"style-module_icon__9F1G9","fullWidth":"style-module_fullWidth__B6GMg","inline":"style-module_inline__td45O","text":"style-module_text__Jv32-","noUnderline":"style-module_noUnderline__tNTBu","largeText":"style-module_largeText__SCr7I","sustainable":"style-module_sustainable__Np5Se","themeClearGreen":"style-module_themeClearGreen__Vlr-5","themeLightGreen":"style-module_themeLightGreen__1iuRT","themeDarkGreen":"style-module_themeDarkGreen__c-rhk","themeDarkBlue":"style-module_themeDarkBlue__yA-D8","themeLightBlue":"style-module_themeLightBlue__2krW8","themeDarkRed":"style-module_themeDarkRed__wbqPU","themeMain":"style-module_themeMain__rNvX2","inverted":"style-module_inverted__CxuAg","button":"style-module_button__QKTN5","filled":"style-module_filled__DLLXx","outlined":"style-module_outlined__pt5fh","themeTrustedBlue":"style-module_themeTrustedBlue__BiKaE"};

const blockWrapper = (Component, inline) => inline ? Component : React.createElement("div", null, Component);
const CallToAction = ({ id, type = "button", variant = "filled", color = "primary", textSize = 16, onClick, href, openInNewTab, children, className, LinkComponent, fullWidth, noUnderline, inline = false, themeColor, icon = "chevron", ...rest }) => {
    const theme = React.useContext(ThemeContext);
    // Set variant to inverted for primary or trustedBlue themes
    variant =
        theme === "primary" || camelcase(theme) === "trustedBlue"
            ? "inverted"
            : variant;
    // Add a themeClass variable to track the current theme, temporary solution
    const themeClass = camelcase(theme) === "trustedBlue" ? "themeTrustedBlue" : "";
    const handleClick = event => {
        event.preventDefault();
        onClick && onClick(event);
    };
    const classes = classNames(style$1b.callToAction, style$1b[type], style$1b[variant], {
        [style$1b.sustainable]: color === "sustainable",
        [style$1b.largeText]: textSize === 18,
        [style$1b.fullWidth]: !!fullWidth,
        [style$1b.noUnderline]: noUnderline,
        [style$1b.inline]: inline,
    }, type === "text" && themeColor && style$1b[themeColor], themeClass && style$1b[themeClass], className);
    if (LinkComponent && href)
        return blockWrapper(React.createElement(LinkComponent, { className: classes, id: id, target: openInNewTab ? "_blank" : "_self", to: href, ...rest },
            React.createElement("span", null, children),
            icon && (React.createElement(Icon, { className: style$1b.icon, name: icon, size: textSize }))), inline);
    return blockWrapper(React.createElement("a", { className: classes, href: href, id: id, onClick: onClick ? handleClick : undefined, rel: "noopener noreferrer", target: openInNewTab ? "_blank" : "_self", ...rest },
        React.createElement("span", null, children),
        React.createElement(Icon, { className: style$1b.icon, name: "chevron", size: textSize })), inline);
};

const AlignmentContext = createContext("Left");

var style$1a = {"typography":"style-module_typography__Sqv-6","h1":"style-module_h1__4OGuV","underline":"style-module_underline__SIHAA","h2":"style-module_h2__LHs-y","h4":"style-module_h4__A6wtT","h5":"style-module_h5__HAY7o","h6":"style-module_h6__hZL3K","subtitle":"style-module_subtitle__qkdCx","subtitle-small":"style-module_subtitle-small__L4hAy","card-title":"style-module_card-title__LxKSE","para-intro":"style-module_para-intro__7W-S6","para-article-intro":"style-module_para-article-intro__A8stO","para":"style-module_para__Fyi-b","para-small":"style-module_para-small__mWcgK","para-x-small":"style-module_para-x-small__SfzHd","para-large":"style-module_para-large__4ZeKT","ol-prefix":"style-module_ol-prefix__q8ehw","search-title":"style-module_search-title__x6o9W","white":"style-module_white__qExFB","darkGrey":"style-module_darkGrey__GqRU-","primary":"style-module_primary__KR02c","midGrey":"style-module_midGrey__ENiIf","lightGrey":"style-module_lightGrey__b7x-V","lightMidGrey":"style-module_lightMidGrey__KZ4b7","primaryGreen":"style-module_primaryGreen__N3fNS","sustainableGreen":"style-module_sustainableGreen__AvceX","fundamentalGreen":"style-module_fundamentalGreen__Asm-x","multiBlue":"style-module_multiBlue__rDRsd","fixedBlue":"style-module_fixedBlue__SIX-w","quantitativeRed":"style-module_quantitativeRed__6h969","trustedBlue":"style-module_trustedBlue__a2WD7","error":"style-module_error__jF7Yx","main":"style-module_main__bt8bx","stix":"style-module_stix__KNIWr","roboto":"style-module_roboto__iowyK","maxLines":"style-module_maxLines__jd4kT","maxLines1":"style-module_maxLines1__-8iHj","maxLines2":"style-module_maxLines2__VGqFk","maxLines3":"style-module_maxLines3__Yc1sh","maxLines4":"style-module_maxLines4__WSuHb","maxLines5":"style-module_maxLines5__8b6B1","maxLines6":"style-module_maxLines6__0OD05","maxLines7":"style-module_maxLines7__wwj7u","maxLines8":"style-module_maxLines8__0cZUj","maxLines9":"style-module_maxLines9__NDVAK","maxLines10":"style-module_maxLines10__CIqEg","removeMargin":"style-module_removeMargin__6Hpm2","primaryTheme":"style-module_primaryTheme__L2c-V","trustedBlueTheme":"style-module_trustedBlueTheme__kiphQ","mainTheme":"style-module_mainTheme__3ZZJg","noRichStyling":"style-module_noRichStyling__5aBF4","alignCenter":"style-module_alignCenter__z-o3t","alignRight":"style-module_alignRight__I-2gx"};

const headerMap = {
    h1: "h1",
    h2: "h2",
    h4: "h4",
    h5: "h5",
    h6: "span",
};
const Typography = ({ children, className, color, variant, underline, removeMargin, noRichStyling, component, maxLines, family, }) => {
    const theme = React.useContext(ThemeContext);
    const alignment = React.useContext(AlignmentContext);
    const classes = classNames(style$1a.typography, variant && style$1a[variant], family && style$1a[family], underline && style$1a.underline, removeMargin && style$1a.removeMargin, maxLines && classNames(style$1a.maxLines, style$1a[`maxLines${maxLines}`]), color && style$1a[color], className !== null && className !== void 0 ? className : className, noRichStyling && style$1a.noRichStyling, theme && !color && style$1a[`${theme}Theme`], alignment && style$1a[`align${alignment}`]);
    const tagProps = {
        className: classes,
    };
    if (variant) {
        if (headerMap[variant]) {
            const Tag = component ||
                headerMap[variant];
            return React.createElement(Tag, { ...tagProps }, children);
        }
        else {
            const Tag = component || "p";
            return React.createElement(Tag, { ...tagProps }, children);
        }
    }
    const Tag = component || "span";
    return React.createElement(Tag, { ...tagProps }, children);
};

var style$19 = {"angleCard":"style-module_angleCard__JRZe4","link":"style-module_link__nPMCn","imageWrapper":"style-module_imageWrapper__AWhWN","iconWrapper":"style-module_iconWrapper__rAnE5","contentWrapper":"style-module_contentWrapper__il8ny","mobileHidden":"style-module_mobileHidden__oKO-t","subCategoryWrapper":"style-module_subCategoryWrapper__IJbIZ","subCategoryTitle":"style-module_subCategoryTitle__5Tgpz","subCategory":"style-module_subCategory__P-M7h","actions":"style-module_actions__CYlu2","grayTheme":"style-module_grayTheme__jXntL","whiteTheme":"style-module_whiteTheme__RoXQN","contentListWrapper":"style-module_contentListWrapper__qTm-r","seperator":"style-module_seperator__QAcZ-","actionsListView":"style-module_actionsListView__T92S7","embedded":"style-module_embedded__-gdk7"};

const AngleCard = ({ id = "AngleCard", image, angleIcon, categoryIcon, categoryClassName, subCategory, publicationDate, shortTitle, LinkComponent, destination, description, embedded = false, ctaLabel = "watch", hideContentMobile, cardView = true, }) => {
    const backgroundTheme = React.useContext(ThemeContext);
    const contentBackground = backgroundTheme === "white" ? "gray" : "white";
    return (React.createElement("section", { className: classNames(categoryClassName, style$19.angleCard, {
            [style$19.embedded]: embedded,
        }), id: id },
        React.createElement(LinkComponent, { className: style$19.link, to: destination },
            cardView && (React.createElement("div", { className: style$19.imageWrapper, id: `${id}-image-wrapper` },
                image,
                angleIcon && (React.createElement("div", { className: style$19.iconWrapper },
                    React.createElement(Icon, { color: "white", name: angleIcon, size: 22 }))))),
            React.createElement("div", { className: classNames(cardView
                    ? classNames(style$19.contentWrapper, `flex-fill`)
                    : classNames(style$19.contentListWrapper), style$19[`${contentBackground}Theme`], { [style$19.mobileHidden]: hideContentMobile }) },
                React.createElement(ThemeContext.Provider, { value: contentBackground },
                    React.createElement("div", { className: classNames(style$19.subCategoryWrapper), id: `${id}-category-wrapper` },
                        React.createElement("div", { className: classNames(style$19.subCategoryTitle) },
                            categoryIcon && (React.createElement(Icon, { className: style$19.subCategoryIcon, color: "primary", name: categoryIcon, size: 16 })),
                            React.createElement(Typography, { className: style$19.subCategory, color: "primary", removeMargin: true, variant: "para-small" }, subCategory)),
                        !cardView && React.createElement("hr", { className: style$19.seperator }),
                        React.createElement(Typography, { className: style$19.subCategory, color: "primary", removeMargin: true, variant: "para-small" }, publicationDate)),
                    React.createElement("div", null,
                        shortTitle,
                        description),
                    React.createElement("div", { className: (!cardView && style$19.actionsListView) },
                        React.createElement(CallToAction, { LinkComponent: LinkComponent, "aria-hidden": "true", href: destination, id: `${id}-CTA`, tabindex: "-1", type: "text" }, ctaLabel)))))));
};

var style$18 = {"wrapper":"style-module_wrapper__D8kpk","imageWrapper":"style-module_imageWrapper__d8Xfm","description":"style-module_description__rEDOf"};

const Author = ({ image, firstName, lastName, description, className, }) => (React.createElement("div", { className: classNames(style$18.wrapper, className) },
    image && React.createElement("div", { className: style$18.imageWrapper }, image),
    React.createElement("div", null,
        React.createElement(Typography, { removeMargin: true, variant: "para-small" }, `${firstName} ${lastName}`),
        description && (React.createElement(Typography, { className: style$18.description, removeMargin: true, variant: "para-small" }, description)))));

var style$17 = {"link":"style-module_link__H8ol-","inline":"style-module_inline__Ze0bH"};

const Link = ({ destination, children, className = "", Component, openInNewTab, variant, ...props }) => {
    const [useComponent, setUseComponent] = useState(false);
    const [isExternal, setIsExternal] = useState(true);
    useEffect(() => {
        let _useComponent = false;
        const { host, pathname } = window.location;
        const external = RegExp(`^((f|ht)tps?:)?//(?!${host})`).test(destination);
        if (destination && !external && pathname !== destination)
            _useComponent = true;
        setIsExternal(external);
        setUseComponent(_useComponent);
    }, []);
    return Component && useComponent && !openInNewTab ? (React.createElement(Component, { className: className, to: destination, ...props }, children)) : (React.createElement("a", { className: classNames(style$17.link, className, variant && style$17[variant]), href: destination || undefined, onMouseDown: event => !destination && event.preventDefault(), rel: "noopener noreferrer", tabIndex: 0, target: isExternal || openInNewTab ? "_blank" : "_self", ...props }, children));
};

var style$16 = {"backLink":"style-module_backLink__QE3uA","text":"style-module_text__mtW-W"};

const BackLink = ({ text, className, ...rest }) => {
    const theme = React.useContext(ThemeContext);
    return (React.createElement(Link, { className: classNames(style$16.backLink, style$16[theme], className), ...rest },
        React.createElement(Typography, { className: style$16.text, color: "primary", removeMargin: true, variant: "card-title" },
            React.createElement(Icon, { color: "primary", name: "arrowLeft", size: 14 }),
            " ",
            text)));
};

var style$15 = {"card":"style-module_card__SX90f","name":"style-module_name__7aC7R","link":"style-module_link__ghahQ","logo":"style-module_logo__yRICH"};

const BrandCard = ({ name, logo, link }) => link ? (React.createElement("a", { className: classNames(style$15.card, style$15.link), href: link, rel: "noreferrer", target: "_blank" },
    React.createElement("div", { className: style$15.logo }, logo),
    React.createElement("span", { className: style$15.name }, name))) : (React.createElement("div", { className: style$15.card },
    React.createElement("div", { className: style$15.logo }, logo),
    React.createElement("span", { className: style$15.name }, name)));

const isSafari = () => {
    var _a, _b;
    return typeof window !== "undefined" &&
        /apple/gi.test((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.vendor) &&
        !/chrome/gi.test((_b = window === null || window === void 0 ? void 0 : window.navigator) === null || _b === void 0 ? void 0 : _b.userAgent);
};

var style$14 = {"button":"style-module_button__Oj7lh","fullWidth":"style-module_fullWidth__FjEUh","filled":"style-module_filled__KRM3B","outlined":"style-module_outlined__kL-V-","inverted":"style-module_inverted__K5voe","icon":"style-module_icon__-aqN1","iconInverted":"style-module_iconInverted__P-BDv","socialButton":"style-module_socialButton__zQ3CD"};

const Button = ({ id, children, onClick, fullWidth, variant = "filled", disabled, iconName, iconFont, iconSize = 15, iconColor, asSocialButton = false, type = "button", ...rest }) => {
    const theme = React.useContext(ThemeContext);
    variant =
        theme !== "primary"
            ? variant
            : variant === "icon"
                ? "iconInverted"
                : "inverted";
    // sometimes safari on mobile refuses to emit click events
    // cursor: pointer; should fix that, but apparently not always
    const handleClick = (touchEvent) => (ev) => {
        touchEvent && ev.preventDefault();
        touchEvent && ev.stopPropagation();
        if (disabled)
            return;
        onClick(ev);
    };
    return (React.createElement("button", { "aria-disabled": disabled, id: id, onClick: handleClick(false), onTouchStart: isSafari() ? handleClick(true) : undefined, type: type, ...rest, className: classNames(style$14.button, style$14[variant], {
            [style$14.fullWidth]: !!fullWidth,
            [style$14.socialButton]: asSocialButton &&
                ["icon", "iconInverted"].includes(variant),
        }, rest.className) }, iconFont || iconName ? (React.createElement(Icon, { color: iconColor, font: iconFont, name: iconName, size: iconSize })) : (children)));
};

var style$13 = {"content":"style-module_content__jxQVQ","cta":"style-module_cta__9IrYE","icon":"style-module_icon__RPQb6","title":"style-module_title__MSuzn"};

const CardIcon = ({ backgroundImage, title, icon, button, color = "white", }) => {
    var _a;
    const cardStyle = backgroundImage
        ? { backgroundImage: `url('${(_a = backgroundImage.image) === null || _a === void 0 ? void 0 : _a.url}')`, color }
        : {};
    return (React.createElement("div", { "aria-label": backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.alt, className: style$13.content, style: cardStyle },
        (icon || title) && (React.createElement("div", null,
            icon && React.createElement("div", { className: style$13.icon }, icon),
            title && React.createElement("h2", { className: style$13.title }, title))),
        button && React.createElement("div", { className: style$13.cta }, button)));
};

const useMediaQuery = (width = 768) => {
    const [isDesktop, setIsDesktop] = useState(false);
    const mdMediaQuery = useRef();
    useEffect(() => {
        var _a, _b;
        if (!window)
            return;
        mdMediaQuery.current = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, `(min-width: ${width}px)`);
        const updateIsDesktop = () => {
            var _a;
            setIsDesktop(((_a = mdMediaQuery === null || mdMediaQuery === void 0 ? void 0 : mdMediaQuery.current) === null || _a === void 0 ? void 0 : _a.matches) || false);
        };
        updateIsDesktop();
        (_b = mdMediaQuery === null || mdMediaQuery === void 0 ? void 0 : mdMediaQuery.current) === null || _b === void 0 ? void 0 : _b.addEventListener("change", updateIsDesktop);
        return () => {
            var _a;
            (_a = mdMediaQuery === null || mdMediaQuery === void 0 ? void 0 : mdMediaQuery.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("change", updateIsDesktop);
        };
    }, []);
    return isDesktop;
};

const useCarouselControls = ({ lastIndex, infinite = false, autoPlay = false, timer = 4000, autoScrollSteps = 1, hovering = false, }) => {
    const isDesktop = useMediaQuery();
    const [activeIndex, setActiveIndex] = useState(0);
    const scroll = useCallback((steps) => {
        const nextIndex = activeIndex + steps;
        if (nextIndex > lastIndex && infinite)
            setActiveIndex(0);
        else if (nextIndex > lastIndex && !infinite)
            setActiveIndex(lastIndex);
        else if (nextIndex < 0)
            setActiveIndex(lastIndex);
        else {
            setActiveIndex(nextIndex);
        }
    }, [activeIndex, lastIndex, infinite]);
    useEffect(() => {
        let t = null;
        if (autoPlay) {
            const moveSlide = () => {
                if (activeIndex < lastIndex)
                    scroll(autoScrollSteps);
                else
                    setActiveIndex(0);
            };
            t = setInterval(moveSlide, timer);
            if (hovering || !isDesktop)
                clearInterval(t);
        }
        return () => {
            if (t)
                clearInterval(t);
        };
    }, [
        hovering,
        isDesktop,
        timer,
        activeIndex,
        lastIndex,
        autoScrollSteps,
        scroll,
        autoPlay,
    ]);
    return { activeIndex, setActiveIndex, scroll };
};

const useHovering = () => {
    const [hovering, setHovering] = useState(false);
    const onMouseEnter = () => setHovering(true);
    const onMouseOver = () => setHovering(true);
    const onMouseLeave = () => setHovering(false);
    return {
        hovering,
        onMouseEnter,
        onMouseLeave,
        onMouseOver,
    };
};

var style$12 = {"carouselBody":"style-module_carouselBody__-wijt","items":"style-module_items__xkXK6","item":"style-module_item__wx-2X","noPeek":"style-module_noPeek__rx1lb","carousel":"style-module_carousel__mc7j1"};

const CarouselBody = ({ items, activeIndex, columns = 1, noGutter, className, }) => (React.createElement("div", { className: classNames(style$12.carouselBody, className) },
    React.createElement(Row, { className: classNames(style$12.items, `flex-nowrap`, {
            [style$12.noPeek]: noGutter,
            "g-0": noGutter,
        }), style: {
            transform: `translateX(-${Math.floor(activeIndex / columns) * 100}%)`,
        } }, React.Children.map(items, (item, i) => {
        var _a;
        return (React.createElement(Col, { className: classNames(style$12.item, "d-flex", noGutter && "g-0"), key: `carouselItem-${((_a = item.props) === null || _a === void 0 ? void 0 : _a.id) || i}`, md: 12 / columns, xs: 12 }, item));
    }))));

var style$11 = {"carouselButton":"style-module_carouselButton__BN3BC","alignOnSimpleNewsCard":"style-module_alignOnSimpleNewsCard__ONngv","alignOnValuesCard":"style-module_alignOnValuesCard__r8FTb","carouselButton__right":"style-module_carouselButton__right__5z9sk"};

/*
    DEPRECATED; use CarouselButton instead
*/
const DeprecatedCarouselButton = ({ flipped, clickHandler, alignOn, }) => (React.createElement("button", { className: classNames(style$11.carouselButton, flipped && style$11[`carouselButton__right`], alignOn && style$11[`alignOn${alignOn}`]), onClick: clickHandler },
    React.createElement(Icon, { color: "darkGrey", name: "arrowLeft" })));

var style$10 = {"carousel":"style-module_carousel__QJHhl"};

const Carousel = ({ children, columnsMdUp, alignButtonsOn, onActiveIndexChange, autoPlay, autoPlayTimer, className, }) => {
    const [lastChildIndex, setLastChildIndex] = useState(0);
    const [columns, setColumns] = useState(columnsMdUp);
    const isDesktop = useMediaQuery();
    const { hovering, ...hoverHandlers } = useHovering();
    const { activeIndex, setActiveIndex, scroll } = useCarouselControls({
        lastIndex: lastChildIndex,
        autoPlay,
        timer: autoPlayTimer,
        hovering,
        autoScrollSteps: columns,
    });
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => scroll(columns),
        onSwipedRight: () => scroll(-columns),
    });
    useEffect(() => {
        setLastChildIndex(React.Children.count(children) - 1);
    }, [children]);
    useEffect(() => {
        setActiveIndex(0);
    }, [columns]);
    useEffect(() => {
        if (isDesktop) {
            setColumns(columnsMdUp);
        }
        else
            setColumns(1);
    }, [columnsMdUp, isDesktop]);
    useEffect(() => {
        onActiveIndexChange && onActiveIndexChange(activeIndex);
    }, [activeIndex]);
    return (React.createElement("div", { ...swipeHandlers, className: classNames(style$10.carousel, className), ...hoverHandlers },
        activeIndex >= columns && (React.createElement(DeprecatedCarouselButton, { alignOn: alignButtonsOn, clickHandler: () => scroll(-columns) })),
        React.createElement(CarouselBody, { activeIndex: activeIndex, columns: columns, items: children }),
        lastChildIndex - activeIndex >= columns && (React.createElement(DeprecatedCarouselButton, { alignOn: alignButtonsOn, clickHandler: () => scroll(columns), flipped: true }))));
};

var style$$ = {"carouselButton":"style-module_carouselButton__xYPpt","flipped":"style-module_flipped__7KYLd"};

const CarouselButton = ({ className, clickHandler, flipped, iconColor = "darkGrey", iconName = "arrowLeft", iconSize = 20, size = 52, }) => (React.createElement("button", { "aria-label": `Slide to the ${flipped ? "right" : "left"}`, className: classNames(className, style$$.carouselButton, flipped && style$$.flipped), onClick: clickHandler, style: {
        width: `${size}px`,
        height: `${size}px`,
    } },
    React.createElement(Icon, { color: iconColor, name: iconName, size: iconSize })));

var style$_ = {"lightBlue":"style-module_lightBlue__Fskkw","lavenderPurple":"style-module_lavenderPurple__yK8vZ","darkGrey":"style-module_darkGrey__7wYNT","cornflowerBlue":"style-module_cornflowerBlue__dDDLw","spaceCadet":"style-module_spaceCadet__3vIE1","pineGreen":"style-module_pineGreen__v4xkg","main":"style-module_main__2mN-Z","container-filled":"style-module_container-filled__NUKFy","header":"style-module_header__d5DB3","titleWrapper":"style-module_titleWrapper__qh3jW","numberContainer":"style-module_numberContainer__v9XES","rank":"style-module_rank__Pm9oq","progressBarAndPercentage":"style-module_progressBarAndPercentage__jDy-Q","progressBarContainer-filled":"style-module_progressBarContainer-filled__S0xR8","progressBar":"style-module_progressBar__OuIiL","progressBar-main":"style-module_progressBar-main__rhYwP","progressBarContainer-transparent":"style-module_progressBarContainer-transparent__I55dB","progressBarContainer-main":"style-module_progressBarContainer-main__qVVig","percentageLabel":"style-module_percentageLabel__5Cy8W","container-transparent":"style-module_container-transparent__1dXhB","container-main":"style-module_container-main__R6-bS"};

const CategoryRow = ({ evolution, score = 0, color = "main", variant = "filled", title, rank, view = "Expanded", }) => {
    const displayPercentage = Math.min(Math.max(score, 0), 100); // Ensure percentage is between 0 and 100
    const arrowIcon = evolution === 0
        ? "subtractCircle"
        : evolution > 0
            ? "arrowUpCircle"
            : "arrowDownCircle";
    return (React.createElement("div", { className: style$_[`container-${variant}`] },
        React.createElement("div", { className: style$_.header },
            React.createElement("div", { className: style$_.titleWrapper }, title),
            view === "Expanded" && (React.createElement("div", { className: style$_.numberContainer },
                React.createElement("span", { className: style$_.rank },
                    "#",
                    rank),
                React.createElement(Icon, { color: variant === "main" ? "white" : "main", name: arrowIcon, size: 24 }),
                React.createElement("span", null, score)))),
        React.createElement("div", { className: style$_.progressBarAndPercentage },
            React.createElement("div", { className: style$_[`progressBarContainer-${variant}`] },
                React.createElement("div", { className: classNames(style$_.progressBar, style$_[color]), style: {
                        width: `${displayPercentage}%`,
                    } })),
            React.createElement("div", { className: style$_.percentageLabel },
                React.createElement("span", null,
                    Math.round(displayPercentage),
                    "%")))));
};

var style$Z = {"columnsItem":"style-module_columnsItem__DqAp-","loadMore":"style-module_loadMore__siY4A"};

const Columns = ({ columns, columnsMobile, children, loadMore }) => {
    const columnsMobileFallback = (typeof columns === "number"
        ? columns
        : parseInt(columns || "0", 10)) >= 4 ||
        (typeof columns === "string" && parseInt(columns || 0, 10) >= 4)
        ? 2
        : 1;
    const isDesktop = useMediaQuery();
    const items = React.Children.toArray(children);
    const [itemsToShow, setItemsToShow] = useState(0);
    useEffect(() => {
        if (loadMore) {
            const itemsBeforeLoadMore = isDesktop
                ? loadMore.desktopItemsBeforeLoadMore
                : loadMore.mobileItemsBeforeLoadMore;
            if (itemsBeforeLoadMore < items.length) {
                setItemsToShow(itemsBeforeLoadMore);
            }
            else
                setItemsToShow(0);
        }
    }, [isDesktop, items.length, loadMore]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `row row-cols-${columnsMobile || columnsMobileFallback} row-cols-md-${columns} g-4 g-md-5 align-items-stretch` }, items
            .slice(0, itemsToShow || items.length)
            .map((child, idx) => (React.createElement("div", { className: classNames("col d-flex flex-column justify-content-start", style$Z.columnsItem), key: `child-${idx}` }, child)))),
        loadMore && !!itemsToShow && (React.createElement("div", { className: style$Z.loadMore },
            React.createElement(Button, { fullWidth: !isDesktop, onClick: () => setItemsToShow(0), type: "button", variant: "outlined" }, loadMore.text)))));
};

const IconWithTooltip = ({ name, color, size, text, id }) => (React.createElement("span", null,
    React.createElement(Icon, { color: color, id: id, name: name, size: size }),
    React.createElement(UncontrolledTooltip, { placement: "bottom", target: id }, text)));

const useClickOutside = (ref, toggler, isActive = true) => {
    useEffect(() => {
        if (!window || !isActive || !toggler || !ref.current)
            return;
        const clickOutsideHandler = (ev) => {
            if (ev.target !== ref.current && !ref.current.contains(ev.target)) {
                toggler(false);
                window.removeEventListener("click", clickOutsideHandler, true);
            }
        };
        window.addEventListener("click", clickOutsideHandler, true);
        return () => {
            window.removeEventListener("click", clickOutsideHandler, true);
        };
    }, [isActive, toggler, ref]);
};

const isArrayWithContent = (thing) => !!thing && Array.isArray(thing) && thing.length > 0;

var style$Y = {"wrapper":"style-module_wrapper__Yyq-e","open":"style-module_open__sIrOR","floating":"style-module_floating__UKZQ1","trigger":"style-module_trigger__OJFS7","chevron":"style-module_chevron__vTN4E","grey":"style-module_grey__woZY1","white":"style-module_white__yEBpR","bold":"style-module_bold__z1kQc","optionsList":"style-module_optionsList__riimP","option":"style-module_option__4JwKo","multiSelectOption":"style-module_multiSelectOption__bUahs","selected":"style-module_selected__dMw3m"};

var style$X = {"input":"style-module_input__yb1Fh","grayBackground":"style-module_grayBackground__EPloA","invalid":"style-module_invalid__hh8Em","primaryBackground":"style-module_primaryBackground__hD-7u"};

const Input = React.forwardRef(({ value, onChange: handleChange, invalid, ...rest }, ref) => {
    const theme = useContext(ThemeContext);
    return (React.createElement(Input$1, { ...rest, className: classNames(style$X.input, "shadow-none", style$X[`${theme}Background`], rest === null || rest === void 0 ? void 0 : rest.className, invalid && style$X.invalid), innerRef: ref, onChange: handleChange, value: value }));
});
Input.displayName = "Input";

const KEY_CODES = {
    BACKSPACE: 8,
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46,
};
const NAV_KEYS = [KEY_CODES.UP, KEY_CODES.DOWN, KEY_CODES.HOME, KEY_CODES.END];
const roleQuerySelector = "[role='option']";
const valueQuerySelector = "data-value";
const getLabelForValue = (value, items) => {
    if (!isArrayWithContent(items))
        return undefined;
    const result = items.find(el => typeof el === "object" ? el.value === value : el === value);
    return typeof result === "object" ? result.label : result;
};
const sortAlpha = (arr, locale) => arr.sort((optA, optB) => {
    const a = typeof optA === "object" ? optA.label : optA;
    const b = typeof optB === "object" ? optB.label : optB;
    return a.localeCompare(b, locale);
});
const Select = ({ id = "Select", multiple = false, value = (multiple ? [] : ""), items, labelId, ariaLabel, emptyValue, onChange, background = "grey", className, optionClassName, disabled, noBoldStyling, tabIndex, locale, floatingOptions, maxSelections, hasInputFilter, shouldSort = true, testId, }) => {
    const [open, toggleOpen] = useState(false);
    const containerRef = useRef(null);
    const listRef = useRef(null);
    const buttonRef = useRef(null);
    const activeItem = useRef(null);
    const query = useRef("");
    const timeout = useRef();
    const initialized = useRef(false);
    const [filterQuery, setFilterQuery] = useState("");
    useClickOutside(containerRef, toggleOpen, open);
    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            return;
        }
        if (activeItem.current)
            activeItem.current = null;
        query.current = "";
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = null;
        }
    }, [items]);
    const handleFocus = () => {
        if (!listRef.current || disabled)
            return;
        const shouldBeSelected = listRef.current.querySelector(`[data-value="${value}"]`);
        if (shouldBeSelected) {
            const somethingElseSelected = listRef.current.querySelector("[aria-selected=true]");
            if ((somethingElseSelected === null || somethingElseSelected === void 0 ? void 0 : somethingElseSelected.getAttribute("data-value")) !== value) {
                deselectItem(somethingElseSelected);
            }
            selectItem(shouldBeSelected);
        }
        !open && toggleOpen(true);
    };
    useEffect(() => {
        setFilterQuery("");
    }, [open]);
    const handleBlur = (ev) => {
        if (ev.currentTarget.nextElementSibling === ev.relatedTarget)
            return;
        activeItem.current = null;
        query.current = "";
        timeout.current = null;
        toggleOpen(false);
    };
    const handleWrapperFocus = (ev) => {
        if (buttonRef.current) {
            buttonRef.current.focus();
            ev.preventDefault();
        }
    };
    const handleTrigger = (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        if (disabled)
            return;
        if (!open && !activeItem.current)
            handleFocus();
        if (!open && activeItem.current)
            toggleOpen(true);
    };
    const selectItem = (element, fromKeyNavigation = false) => {
        listRef.current.querySelectorAll("[data-value]").forEach(deselectItem);
        if (!element)
            return;
        if (fromKeyNavigation && items.length > 5) {
            element.scrollIntoView(false);
        }
        element.setAttribute("aria-selected", "true");
        activeItem.current = element;
    };
    const deselectItem = (element) => element && element.setAttribute("aria-selected", "false");
    const clearQueryAfterDelay = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = null;
        }
        timeout.current = setTimeout(() => {
            query.current = "";
            timeout.current = null;
        });
    };
    const handleSubmit = (val) => {
        toggleOpen(false);
        if (multiple) {
            if (maxSelections &&
                value.length >= maxSelections &&
                !value.includes(val))
                return;
            const newValue = Array.isArray(value) && value.includes(val)
                ? value.filter(v => v !== val)
                : [...value, val];
            onChange(newValue);
        }
        else {
            onChange(val);
        }
    };
    const handleClick = (ev) => {
        var _a, _b, _c, _d;
        const value = (_b = (_a = ev.target.dataset) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : (_d = (_c = ev.target.parentElement) === null || _c === void 0 ? void 0 : _c.dataset) === null || _d === void 0 ? void 0 : _d.value;
        if (value === undefined || value === null)
            return;
        selectItem(ev.target);
        handleSubmit(value);
    };
    const getItemForKey = (key) => {
        var _a;
        const selectLastItem = () => {
            const items = listRef.current.querySelectorAll(roleQuerySelector);
            return (items === null || items === void 0 ? void 0 : items.length) ? items[items.length - 1] : null;
        };
        switch (key) {
            case KEY_CODES.UP: {
                if (activeItem.current)
                    return activeItem.current.previousElementSibling;
                return selectLastItem();
            }
            case KEY_CODES.DOWN:
                return activeItem.current
                    ? activeItem.current.nextElementSibling
                    : (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(roleQuerySelector);
            case KEY_CODES.HOME:
                return;
            case KEY_CODES.END:
                return selectLastItem();
            default:
                return null;
        }
    };
    const handleKeyDown = (ev) => {
        ev.stopPropagation();
        if (!listRef.current)
            return;
        if (ev.metaKey || ev.ctrlKey || ev.altKey)
            return;
        const key = ev.which || ev.keyCode;
        if (!activeItem.current && NAV_KEYS.includes(key)) {
            ev.preventDefault();
            if (!open)
                toggleOpen(true);
            const firstItem = listRef.current.querySelector(roleQuerySelector);
            selectItem(firstItem);
            return;
        }
        if (!activeItem.current)
            return;
        switch (key) {
            case KEY_CODES.ESC: {
                toggleOpen(false);
                selectItem(null);
                break;
            }
            case KEY_CODES.UP:
            case KEY_CODES.DOWN:
            case KEY_CODES.HOME:
            case KEY_CODES.END: {
                ev.preventDefault();
                if (!open)
                    toggleOpen(true);
                const itemToSelect = getItemForKey(key);
                itemToSelect && selectItem(itemToSelect, true);
                break;
            }
            case KEY_CODES.SPACE:
            case KEY_CODES.RETURN: {
                ev.preventDefault();
                const value = activeItem.current.getAttribute(valueQuerySelector);
                value !== undefined && value !== null && handleSubmit(value);
                break;
            }
            default: {
                selectMatchingElements(key);
                break;
            }
        }
    };
    const selectMatchingElements = (key) => {
        const char = String.fromCharCode(key);
        query.current += char;
        clearQueryAfterDelay();
        const items = listRef.current.querySelectorAll(roleQuerySelector);
        for (let i = 0; i < items.length; i++) {
            let value = items[i].getAttribute(valueQuerySelector);
            value = value && value.toLowerCase();
            if (value.indexOf(query.current.toLowerCase()) > -1) {
                selectItem(items[i]);
                break;
            }
        }
    };
    const handleFilterChange = (event) => {
        setFilterQuery(event.target.value);
    };
    const filteredItems = hasInputFilter
        ? items.filter(item => typeof item === "object"
            ? item.label.toLowerCase().includes(filterQuery.toLowerCase())
            : item.toLowerCase().includes(filterQuery.toLowerCase()))
        : items;
    const sortedItems = shouldSort
        ? sortAlpha(filteredItems, locale)
        : filteredItems;
    return (React.createElement("div", { className: classNames(style$Y.wrapper, style$Y[background], { [style$Y.open]: open, [style$Y.floating]: floatingOptions }, className), "data-testid": testId, id: id, onFocus: handleWrapperFocus, ref: containerRef },
        open && hasInputFilter ? (React.createElement(React.Fragment, null,
            React.createElement(Input, { autofocus: true, className: style$Y.input, onChange: handleFilterChange, placeholder: "Search" }))) : (React.createElement("button", { "aria-disabled": disabled, "aria-haspopup": "listbox", "aria-label": ariaLabel, "aria-labelledby": labelId, className: style$Y.trigger, id: `${id}-trigger`, onBlur: handleBlur, onClick: handleTrigger, onFocus: handleFocus, onKeyDown: handleKeyDown, ref: buttonRef, tabIndex: tabIndex },
            React.createElement(Typography, { className: classNames(optionClassName, {
                    [style$Y.bold]: !!value && !noBoldStyling,
                }), removeMargin: true, variant: "para-small" }, typeof value === "string"
                ? getLabelForValue(value, items)
                : emptyValue || ""),
            React.createElement(Icon, { className: style$Y.chevron, color: "primary", name: "chevron", size: 16 }))),
        React.createElement("ul", { className: classNames(style$Y.optionsList, {
                [style$Y.open]: open,
                [style$Y.floating]: floatingOptions,
            }), id: `${id}-optionsList`, ref: listRef, role: "listbox", tabIndex: -1 }, isArrayWithContent(sortedItems) &&
            sortedItems.map(item => (React.createElement("li", { className: classNames(style$Y.option, multiple ? style$Y.multiSelectOption : "", multiple &&
                    value.includes(typeof item === "object"
                        ? item.value
                        : item)
                    ? style$Y.selected
                    : ""), "data-value": typeof item === "object" ? item.value : item, key: `option-${typeof item === "string" ? item : item.label}`, onClick: handleClick, role: "option" },
                React.createElement(Typography, { className: classNames(optionClassName) }, typeof item === "object"
                    ? item.label
                    : item === ""
                        ? " - "
                        : item),
                multiple &&
                    value.includes(typeof item === "object"
                        ? item.value
                        : item) && (React.createElement(Icon, { className: style$Y.chevron, color: "multiBlue", name: "check", size: 16 }))))))));
};

var style$W = {"compareFunds":"style-module_compareFunds__6IzCt","rightBorder":"style-module_rightBorder__iJiyE","categoryCell":"style-module_categoryCell__5zQZ8","bottomBorder":"style-module_bottomBorder__CqTkm","headingCell":"style-module_headingCell__eaX2y","select":"style-module_select__UTXhk","bold":"style-module_bold__W5zO5","link":"style-module_link__fbjGu","smallLabel":"style-module_smallLabel__4Crmh","penultimate":"style-module_penultimate__vr6X1","nowrap":"style-module_nowrap__cRKnv"};

const groupFundsByCategory = (funds) => funds.reduce((object, fund) => {
    if (!object[fund.category.name])
        object[fund.category.name] = [fund];
    else
        object[fund.category.name] =
            object[fund.category.name].concat(fund);
    return object;
}, []);
const LabelWithCheck = ({ label }) => (React.createElement(Typography, { className: style$W.smallLabel, removeMargin: true, variant: "para-small" },
    React.createElement(Icon, { color: "primary", name: "check", size: 13 }),
    " ",
    React.createElement("span", null, label)));
const fundFields = [
    "fundName",
    "normativeScreening",
    "exclusions",
    "bestInClass",
    "sustainableThematicApproach",
];
const hideOnMobile = "d-none d-md-table-cell";
const RenderFundsForCategory = ({ category, funds, fieldLabels, }) => (React.createElement(Fragment, { key: category }, funds.map((fund, idx) => (React.createElement("tr", { className: classNames({
        [style$W.bottomBorder]: idx === funds.length - 1,
    }), key: `${category}-row-${fund.fundName}` },
    idx === 0 && (React.createElement("td", { className: classNames(style$W.categoryCell, style$W.nowrap, hideOnMobile), rowSpan: funds.length },
        React.createElement(Typography, { className: style$W.bold, color: "primary", removeMargin: true, variant: "para-small" }, category))),
    fundFields.map((key, secondIdx) => (React.createElement("td", { className: classNames({
            [hideOnMobile]: secondIdx > 0,
            [style$W.nowrap]: secondIdx === 0,
            [style$W.rightBorder]: secondIdx < Object.keys(fund).length - 3,
        }), key: `${category}-col-${key}` },
        key === "fundName" && (React.createElement(Link, { className: style$W.link, destination: fund.fundLink }, fund[key])),
        key !== "fundName" && fund[key] !== false ? (React.createElement(Icon, { name: "check", size: 20 })) : (" ")))),
    React.createElement("td", { className: "d-md-none" },
        fund.normativeScreening && (React.createElement(LabelWithCheck, { label: fieldLabels.normativeScreening })),
        fund.exclusions && (React.createElement(LabelWithCheck, { label: fieldLabels.exclusions })),
        fund.bestInClass && (React.createElement(LabelWithCheck, { label: fieldLabels.bestInClass })),
        fund.sustainableThematicApproach && (React.createElement(LabelWithCheck, { label: fieldLabels.sustainableThematicApproach }))))))));
const CompareFunds = ({ funds, selectLabel, headings, fieldLabels, tooltips, }) => {
    const [activeCategory, setActiveCategory] = useState(funds === null || funds === void 0 ? void 0 : funds[0].category.name);
    const isDesktop = useMediaQuery();
    const categoryOptions = useMemo(() => funds.reduce((list, fund) => !list.includes(fund.category.name)
        ? list.concat(fund.category.name)
        : list, []), [funds]);
    const fundsByCategory = useMemo(() => groupFundsByCategory(funds), [funds]);
    useEffect(() => {
        if (isDesktop && activeCategory !== funds[0].category.name)
            setActiveCategory(funds[0].category.name);
    }, [isDesktop, activeCategory, funds]);
    return (React.createElement("div", { className: style$W.compareFunds },
        React.createElement("label", { className: "d-block d-md-none", htmlFor: "label-select-category", id: "label-select-category" },
            React.createElement(Typography, { removeMargin: true, variant: "para-small" }, selectLabel),
            React.createElement(Select, { background: "white", className: style$W.select, floatingOptions: true, items: categoryOptions, labelId: "label-select-category", onChange: setActiveCategory, value: activeCategory })),
        React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("td", { className: classNames(hideOnMobile, style$W.headingCell) },
                        React.createElement(Typography, { color: "primary", variant: "subtitle-small" }, headings.assetClass)),
                    React.createElement("td", { className: style$W.headingCell },
                        React.createElement(Typography, { color: "primary", removeMargin: true, variant: "subtitle-small" }, headings.fundName)),
                    React.createElement("td", { className: classNames(hideOnMobile, style$W.headingCell) },
                        React.createElement(Typography, { color: "primary", removeMargin: true, variant: "subtitle-small" },
                            headings.normativeScreening,
                            " ",
                            (tooltips === null || tooltips === void 0 ? void 0 : tooltips.normativeScreening) && (React.createElement(IconWithTooltip, { id: "normative-screening-info", name: "info", size: 16, text: "lorem ipsum" })))),
                    React.createElement("td", { className: classNames(hideOnMobile, style$W.headingCell) },
                        React.createElement(Typography, { color: "primary", removeMargin: true, variant: "subtitle-small" },
                            headings.exclusions,
                            " ",
                            (tooltips === null || tooltips === void 0 ? void 0 : tooltips.exclusions) && (React.createElement(IconWithTooltip, { id: "exclusions-info", name: "info", size: 16, text: "lorem ipsum" })))),
                    React.createElement("td", { className: classNames(hideOnMobile, style$W.headingCell) },
                        React.createElement(Typography, { color: "primary", removeMargin: true, variant: "subtitle-small" },
                            headings.bestInClass,
                            " ",
                            (tooltips === null || tooltips === void 0 ? void 0 : tooltips.bestInClass) && (React.createElement(IconWithTooltip, { id: "best-in-class-info", name: "info", size: 16, text: "lorem ipsum" })))),
                    React.createElement("td", { className: classNames(style$W.headingCell, style$W.penultimate, hideOnMobile) },
                        React.createElement(Typography, { color: "primary", removeMargin: true, variant: "subtitle-small" },
                            headings.sustainableThematicApproach,
                            " ",
                            (tooltips === null || tooltips === void 0 ? void 0 : tooltips.sustainableThematicApproach) && (React.createElement(IconWithTooltip, { id: "sustainable-info", name: "info", size: 16, text: "lorem ipsum" })))),
                    React.createElement("td", { className: classNames("d-md-none", style$W.headingCell) }, " "))),
            React.createElement("tbody", null, !isDesktop ? (React.createElement(RenderFundsForCategory, { category: activeCategory, fieldLabels: fieldLabels, funds: fundsByCategory[activeCategory] })) : (Object.entries(fundsByCategory).map(([category, funds]) => (React.createElement(RenderFundsForCategory, { category: category, fieldLabels: fieldLabels, funds: funds, key: category }))))))));
};

var style$V = {"contactPoint":"style-module_contactPoint__F8u36","embedded":"style-module_embedded__BRGpG","primary":"style-module_primary__jBDp8"};

const ContactPoint = ({ email, address, title, phone, className, embedded, }) => {
    const phoneNormalized = phone === null || phone === void 0 ? void 0 : phone.replaceAll(" ", "");
    const theme = React.useContext(ThemeContext);
    const Element = embedded ? "span" : "div";
    return (React.createElement(Element, { className: classNames(style$V.contactPoint, style$V[theme], { [style$V.embedded]: embedded }, className) },
        title && (React.createElement(Typography, { removeMargin: true, variant: "para" },
            React.createElement("b", null, title))),
        address && (React.createElement(Typography, { removeMargin: true, variant: "para" }, address)),
        phone && (React.createElement(Typography, { removeMargin: true, variant: "para" },
            React.createElement("a", { href: `tel:${phoneNormalized}` }, phone))),
        React.createElement(Typography, { removeMargin: true, variant: "para" },
            React.createElement("a", { href: `mailto:${email}` }, email))));
};

var style$U = {"countryBlock":"style-module_countryBlock__Es1Uo","activeBlock":"style-module_activeBlock__qxTuY","flagAndName":"style-module_flagAndName__yoK-v","score":"style-module_score__wuzGW","ranking":"style-module_ranking__NIoCL","icon":"style-module_icon__2SuGc","moveAndScore":"style-module_moveAndScore__1R02w","accordionContent":"style-module_accordionContent__D0f1y","open":"style-module_open__6RLF8"};

var style$T = {"flagContainer":"style-module_flagContainer__30If4","small":"style-module_small__gx8c9","large":"style-module_large__t61VS","flagImage":"style-module_flagImage__qXsZM"};

const Flag = ({ country, size = "small" }) => {
    const countryData = countries.find((c) => c.name.toLowerCase() === country.toLowerCase());
    const flagUrl = countryData
        ? countryData.flag
        : "https://placehold.co/1000x600";
    return (React.createElement("div", { className: classNames(style$T.flagContainer, style$T[`${size}`]) },
        React.createElement("img", { alt: `flag ${country}`, className: style$T.flagImage, src: flagUrl })));
};

const CountryBlock = ({ name, countryNameEnglish, ranking, move, score, isActive, setActive, children, categories, chosenCategory, }) => {
    var _a, _b;
    const isDesktop = useMediaQuery(1024);
    const foundChosenCategory = categories === null || categories === void 0 ? void 0 : categories.find(cat => cat.title === chosenCategory);
    const shownRank = (_a = foundChosenCategory === null || foundChosenCategory === void 0 ? void 0 : foundChosenCategory.rank) !== null && _a !== void 0 ? _a : ranking;
    const shownScore = (_b = foundChosenCategory === null || foundChosenCategory === void 0 ? void 0 : foundChosenCategory.score) !== null && _b !== void 0 ? _b : score;
    return (React.createElement("div", { className: style$U.countryBlockWrapper },
        React.createElement("div", { className: classNames(style$U.countryBlock, isActive && style$U.activeBlock), onClick: () => setActive(name) },
            React.createElement("div", { className: style$U.flagAndName },
                countryNameEnglish && (React.createElement(Flag, { country: countryNameEnglish })),
                React.createElement("span", null, name)),
            React.createElement("span", { className: style$U.ranking },
                "# ",
                shownRank),
            React.createElement("div", { className: style$U.moveAndScore },
                React.createElement(Icon, { color: isActive ? "white" : "main", name: move, size: 24 }),
                React.createElement("span", { className: style$U.score }, shownScore))),
        isActive && !isDesktop && children && (React.createElement("div", { className: classNames(style$U.accordionContent, style$U.open) }, children))));
};

var style$S = {"countryDetailBlock":"style-module_countryDetailBlock__Jvw-I","buttonContainer":"style-module_buttonContainer__wugkT","categoryListHidden":"style-module_categoryListHidden__TOhMR","categoryList":"style-module_categoryList__IOfv9"};

var style$R = {"cta":"style-module_cta__XDlPO","white":"style-module_white__-0ym0","filled":"style-module_filled__UuPIm","outlined":"style-module_outlined__FBbGu","inverted":"style-module_inverted__5ZANs","darkGrey":"style-module_darkGrey__43Hol","primary":"style-module_primary__-56vV","midGrey":"style-module_midGrey__Srpid","lightGrey":"style-module_lightGrey__6umqn","lightMidGrey":"style-module_lightMidGrey__O3Ush","primaryGreen":"style-module_primaryGreen__LZhNB","sustainableGreen":"style-module_sustainableGreen__ZMPvg","fundamentalGreen":"style-module_fundamentalGreen__gS9AO","multiBlue":"style-module_multiBlue__KUm2x","fixedBlue":"style-module_fixedBlue__xyxZp","quantitativeRed":"style-module_quantitativeRed__fdkcC","trustedBlue":"style-module_trustedBlue__9q--l","error":"style-module_error__Qe8Tt","main":"style-module_main__34L53","end":"style-module_end__GP-SP","fullWidth":"style-module_fullWidth__QCvgP"};

const CTA = ({ children, className, color = "main", disabled, fullWidth, href, iconName, iconPosition = "end", iconSize = 15, id, onClick, type = "button", variant = "filled", tabIndex = 0, ...props }) => {
    const ctaProps = {
        "aria-disabled": disabled,
        disabled,
        className: classNames(className, style$R.cta, style$R[color], style$R[variant], style$R[iconPosition], {
            [style$R.fullWidth]: fullWidth,
        }),
        id,
        onClick,
    };
    const Content = () => (React.createElement(React.Fragment, null,
        iconName && React.createElement(Icon, { name: iconName, size: iconSize }),
        children));
    if (href) {
        return (React.createElement("a", { href: href, tabIndex: tabIndex, ...ctaProps, ...props },
            React.createElement(Content, null)));
    }
    return (React.createElement("button", { role: "button", ...ctaProps, tabIndex: tabIndex, type: type, ...props },
        React.createElement(Content, null)));
};

const CountryDetailBlock = ({ categories, overallScore, handleClick, handleCompare, hideButtons, progressBarColor, view, labelCompareBtn, labelDetailBtn, }) => {
    var _a, _b, _c, _d;
    return (React.createElement("div", { className: style$S.countryDetailBlock },
        React.createElement("div", { className: style$S.overallScore },
            React.createElement(CategoryRow, { color: progressBarColor !== null && progressBarColor !== void 0 ? progressBarColor : "main", evolution: (_a = overallScore === null || overallScore === void 0 ? void 0 : overallScore.evolution) !== null && _a !== void 0 ? _a : 0, rank: (_b = overallScore === null || overallScore === void 0 ? void 0 : overallScore.rank) !== null && _b !== void 0 ? _b : 0, score: (_c = overallScore === null || overallScore === void 0 ? void 0 : overallScore.score) !== null && _c !== void 0 ? _c : 0, title: (_d = overallScore === null || overallScore === void 0 ? void 0 : overallScore.title) !== null && _d !== void 0 ? _d : "", variant: "transparent", view: "Expanded" })),
        React.createElement("div", { className: hideButtons ? style$S.categoryListHidden : style$S.categoryList }, categories === null || categories === void 0 ? void 0 : categories.map((category, index) => (React.createElement(CategoryRow, { color: progressBarColor !== null && progressBarColor !== void 0 ? progressBarColor : "main", evolution: category.evolution, key: index, rank: category.rank, score: category.score, title: category.title, variant: "filled", view: view })))),
        !hideButtons && (React.createElement("div", { className: style$S.buttonContainer },
            React.createElement(CTA, { className: style$S.seeMoreDetailsButton, color: "sustainableGreen", fullWidth: true, onClick: handleClick, type: "button", variant: "filled" },
                labelDetailBtn,
                " >"),
            React.createElement(CTA, { className: style$S.compareButton, color: "multiBlue", fullWidth: true, onClick: handleCompare, type: "button", variant: "outlined" }, labelCompareBtn)))));
};

var style$Q = {"headerContainer":"style-module_headerContainer__wRgy4","container":"style-module_container__Dvqai","ranking":"style-module_ranking__IMF6I","move":"style-module_move__h7Tet","moveAndScore":"style-module_moveAndScore__CyRDo","buttonList":"style-module_buttonList__qpCGV"};

/**
 * CountryList component displays a list of countries with ranking, move, and score information.
 * It also includes a "Show More" button to load additional countries.
 *
 * @param {CountriesListProps} props - The props for the CountryList component.
 * @returns {JSX.Element} The rendered CountryList component.
 */
const CountryList = ({ countries, activeCountry, setActiveCountry, translations = {}, handleClick, handleCompare, chosenCategory, languageInitialized, labelCompareBtn, labelDetailBtn, }) => {
    const [visibleCount, setVisibleCount] = useState(10);
    const [internalActive, setInternalActive] = useState(null);
    const isTablet = useMediaQuery(768);
    useEffect(() => {
        if (!activeCountry && countries.length && languageInitialized) {
            (typeof setActiveCountry === "function"
                ? setActiveCountry
                : setInternalActive)(countries[0]);
        }
        if (activeCountry && countries.length) {
            const activeIndex = countries.findIndex(country => country.countryNameEnglish ===
                activeCountry.countryNameEnglish);
            if (activeIndex + 1 > 10) {
                setVisibleCount(prev => Math.max(activeIndex + 1, Math.min(prev + 10, countries.length)));
            }
        }
    }, [countries, activeCountry, setActiveCountry]);
    const handleActive = (country) => {
        const newActiveCountry = country.name === (effectiveActive === null || effectiveActive === void 0 ? void 0 : effectiveActive.name) ? null : country;
        if (newActiveCountry !== null) {
            (typeof setActiveCountry === "function"
                ? setActiveCountry
                : setInternalActive)(newActiveCountry);
        }
        else {
            (typeof setActiveCountry === "function"
                ? setActiveCountry
                : setInternalActive)(null);
        }
    };
    const effectiveActive = activeCountry || internalActive || countries[0] || null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: style$Q.headerContainer },
            React.createElement("span", null, translations.rank || "Rank"),
            React.createElement("span", null, translations.move || "Move"),
            React.createElement("span", null, translations.score || "Score")),
        React.createElement("div", { className: style$Q.container }, countries.slice(0, visibleCount).map((country, i) => {
            var _a, _b;
            return (React.createElement(CountryBlock, { key: i, ...country, chosenCategory: chosenCategory, isActive: (effectiveActive === null || effectiveActive === void 0 ? void 0 : effectiveActive.name) === country.name, setActive: () => handleActive(country) }, (effectiveActive === null || effectiveActive === void 0 ? void 0 : effectiveActive.name) === country.name && (React.createElement(CountryDetailBlock, { categories: (_a = country.categories) !== null && _a !== void 0 ? _a : [], handleClick: handleClick, handleCompare: handleCompare, labelCompareBtn: labelCompareBtn, labelDetailBtn: labelDetailBtn, overallScore: (_b = country.overallScore) !== null && _b !== void 0 ? _b : {
                    evolution: 0,
                    rank: 0,
                    score: 0,
                    title: "",
                }, view: isTablet ? "Expanded" : "Minimal" }))));
        })),
        visibleCount < countries.length && (React.createElement(Button, { className: style$Q.buttonList, fullWidth: true, onClick: () => setVisibleCount(prev => Math.min(prev + 10, countries.length)), type: "button", variant: "filled" }, translations.buttonTitle || "See more countries"))));
};

var style$P = {"ctaOverlayContent":"style-module_ctaOverlayContent__3zUwX","title":"style-module_title__dSsoc","white":"style-module_white__HepZH","primary":"style-module_primary__cEKnF"};

const CtaOverlayContent = ({ title, content, className }) => {
    const theme = React.useContext(ThemeContext);
    return (React.createElement("article", { className: classNames(style$P.ctaOverlayContent, className) },
        title && (React.createElement(Typography, { className: classNames(style$P.title, {
                [style$P.white]: theme === "primary",
                [style$P.primary]: theme !== "primary",
            }), color: theme !== "primary" ? "primary" : "white", variant: "subtitle-small" }, title)),
        content));
};

var style$O = {"ctaRound":"style-module_ctaRound__wf5Gy"};

const CTARound = ({ className, iconName = "chevron", ...props }) => (React.createElement(CTA, { className: classNames(className, style$O.ctaRound), iconName: iconName, ...props }));

var style$N = {"divider":"style-module_divider__yucxQ","compact":"style-module_compact__aps4F","primary":"style-module_primary__vhYiy"};

const Divider = ({ className, ...Props }) => {
    const theme = React.useContext(ThemeContext);
    return (React.createElement("hr", { className: classNames(className, style$N.divider, style$N[theme]), ...Props }));
};

var style$M = {"document":"style-module_document__KEP8G","btn":"style-module_btn__rLuDm","icon":"style-module_icon__w27ij","content":"style-module_content__XRpWF","date":"style-module_date__4Mwzz","label":"style-module_label__RmDeX","action":"style-module_action__YAuCX","grayBg":"style-module_grayBg__mzVp7","primaryBg":"style-module_primaryBg__g7cyK"};

const Document = ({ date, label, url, actionLabel }) => {
    const containerBackground = useContext(ThemeContext);
    const inverted = containerBackground === "primary";
    return (React.createElement("div", { className: classNames(style$M.document, style$M[`${containerBackground}Bg`]) },
        React.createElement("a", { className: style$M.btn, download: true, href: url },
            React.createElement(ThemeContext.Provider, { value: inverted ? "white" : "gray" },
                React.createElement("div", { className: `${style$M.icon} icon-file` }))),
        React.createElement("div", { className: style$M.content },
            React.createElement("div", { className: style$M.date }, date),
            React.createElement("div", { className: style$M.label }, label),
            React.createElement("div", { className: style$M.action },
                React.createElement("a", { href: url, rel: "noopener noreferrer", target: "_blank" }, actionLabel)))));
};

var style$L = {"faqCollection":"style-module_faqCollection__uLgx-"};

const FaqCollection = ({ children, className }) => {
    const [openQuestion, setOpenQuestion] = useState("");
    const toggle = (targetId) => targetId === openQuestion
        ? setOpenQuestion("")
        : setOpenQuestion(targetId);
    // Destructuring workaround for toggle because RS props typing is wrong
    return (React.createElement(Accordion, { open: openQuestion, ...{ toggle }, className: classNames(style$L.faqCollection, className) }, React.Children.map(children, child => React.cloneElement(child, { ...child.props, openQuestion }))));
};

var style$K = {"faqItem":"style-module_faqItem__7gB7c","itemHeader":"style-module_itemHeader__-vPYq","chevron":"style-module_chevron__kpyvI","alignCenter":"style-module_alignCenter__RKhTj","alignRight":"style-module_alignRight__FwREr","question":"style-module_question__CCl0g","itemBody":"style-module_itemBody__dNsaD","active":"style-module_active__Xw34n","primary":"style-module_primary__P5jK3"};

const FaqItem = ({ question, children, id, openQuestion, className, }) => {
    const theme = useContext(ThemeContext);
    const alignment = useContext(AlignmentContext);
    return (React.createElement(AccordionItem, { className: classNames(style$K.faqItem, className, {
            [style$K.active]: openQuestion === id,
            [style$K[theme]]: theme,
        }), key: id },
        React.createElement(AccordionHeader, { className: classNames(style$K.itemHeader, alignment && style$K[`align${alignment}`]), tag: "h3", targetId: id },
            React.createElement(Typography, { className: style$K.question, color: theme === "primary" ? "white" : "darkGrey", removeMargin: true, variant: "para" }, question),
            React.createElement(Icon, { className: style$K.chevron, color: theme === "primary" ? "white" : "midGrey", name: "chevron", size: 30 })),
        React.createElement(AccordionBody, { accordionId: id, className: style$K.itemBody }, children)));
};

var style$J = {"featuredCard":"style-module_featuredCard__B05QM","image":"style-module_image__9qgU3","content":"style-module_content__a93ZO","primary":"style-module_primary__U538q","gray":"style-module_gray__ofCoU","trustedBlue":"style-module_trustedBlue__vLfXy"};

const FeaturedCard = ({ image, content, theme }) => (React.createElement("article", { className: style$J.featuredCard },
    React.createElement("div", { className: style$J.image }, image),
    React.createElement("div", { className: classNames(style$J.content, style$J[theme]) },
        React.createElement(ThemeContext.Provider, { value: theme }, content))));

var style$I = {"footer":"style-module_footer__Swk60","wrapper":"style-module_wrapper__Z8HjC","link":"style-module_link__AJtyT","footerHeader":"style-module_footerHeader__CQxU3","footerNav":"style-module_footerNav__o6s8Q","logo":"style-module_logo__c4PA4","info":"style-module_info__x-Sv-","links":"style-module_links__-T-Ue","socials":"style-module_socials__8kho-","icon":"style-module_icon__krAPn","form":"style-module_form__-xb9T","copyRightWrapper":"style-module_copyRightWrapper__i8vpT","toTop":"style-module_toTop__96Mkf","fab":"style-module_fab__fTvqz","social":"style-module_social__vjlGa"};

const Footer = ({ companyInfo, copyrightInfo, header, LinkComponent, links, logo, newsLetterReference, showFab = false, socials, toTopText, }) => (React.createElement("footer", { className: style$I.footer },
    React.createElement(Container, { className: style$I.wrapper },
        header && React.createElement("div", { className: style$I.footerHeader }, header),
        React.createElement(Row, { className: style$I.footerNav },
            React.createElement(Col, { className: style$I.form, lg: 4, md: 6 }, newsLetterReference),
            React.createElement(Col, { lg: 3, md: 6 },
                React.createElement("div", { className: style$I.logo }, logo),
                React.createElement("div", { className: style$I.info }, companyInfo)),
            React.createElement(Col, { className: style$I.links, lg: 3, xs: 6 }, links === null || links === void 0 ? void 0 : links.map((link, i) => (React.createElement(Link, { Component: LinkComponent, className: style$I.link, destination: link.destination, key: i, openInNewTab: link.openInNewTab }, link.text)))),
            React.createElement(Col, { className: style$I.socials, lg: 2, xs: 6 }, socials === null || socials === void 0 ? void 0 : socials.map((social, i) => (React.createElement(Link, { Component: LinkComponent, className: style$I.link, destination: social.destination, key: i },
                React.createElement(Icon, { className: style$I.icon, color: "main", name: social.icon, size: 19 }),
                social.text))))),
        React.createElement(Row, { className: style$I.copyRightWrapper },
            React.createElement(Col, { className: style$I.copyRight, md: 6 }, copyrightInfo),
            React.createElement(Col, { className: style$I.toTop, md: 6 },
                React.createElement("a", { "aria-label": toTopText, className: style$I.link, href: "#top" }, toTopText !== null && toTopText !== void 0 ? toTopText : "Back to top",
                    React.createElement(Icon, { className: style$I.icon, color: "darkGrey", name: "arrowUp" })))),
        showFab && (React.createElement("a", { "aria-label": toTopText, className: style$I.fab, href: "#top", role: "button" },
            React.createElement(Icon, { className: style$I.icon, color: "darkGrey", name: "arrowUp" }))))));

var style$H = {"button":"style-module_button__tP62Q","hamburger":"style-module_hamburger__ozF-3","inverted":"style-module_inverted__peufe","open":"style-module_open__qzktg"};

const Hamburger = ({ open, onToggle: handleToggle, inverted }) => (React.createElement("button", { "aria-label": "Open main menu", className: style$H.button, onClick: handleToggle, role: "button", tabIndex: 0 },
    React.createElement("div", { className: classNames(style$H.hamburger, open && style$H.open, inverted && style$H.inverted) },
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null))));

var style$G = {"hero":"style-module_hero__dE5uJ","imageWrapper":"style-module_imageWrapper__fr240","dimmed":"style-module_dimmed__hzC6G","landingPage":"style-module_landingPage__FQ5fF","titleDivider":"style-module_titleDivider__wiCiZ","heroContent":"style-module_heroContent__F-ceA","removeTitleBar":"style-module_removeTitleBar__HMnYM","colorBlock":"style-module_colorBlock__wa9B6","smallSubtitle":"style-module_smallSubtitle__TVX4M","intro":"style-module_intro__VNzgf","onlyTitle":"style-module_onlyTitle__gzFvu","descriptionForTitle":"style-module_descriptionForTitle__tm1cF","subtitleDescription":"style-module_subtitleDescription__Cmz7p","onlyDescription":"style-module_onlyDescription__Rq2st"};

const Hero = ({ image, id = "hero", title, titleColor = "white", description, subtitle, landingPage = false, wrapperClassName, contentClassName, dimmed, underline, }) => {
    const showDividerInColorBlock = underline && (!!subtitle || (title && !description && !subtitle));
    return (React.createElement("div", { className: classNames(style$G.hero, {
            [style$G.landingPage]: landingPage,
        }, wrapperClassName), id: id },
        image &&
            React.cloneElement(image, {
                className: classNames(style$G.imageWrapper, {
                    [style$G.dimmed]: dimmed,
                }),
            }),
        React.createElement("div", { className: classNames(style$G.heroContent, contentClassName), id: `${id}-content` },
            title && description && !subtitle && (React.createElement(Typography, { color: titleColor, underline: underline, variant: "h1" }, title)),
            React.createElement("div", { className: classNames(style$G.colorBlock, {
                    [style$G.onlyDescription]: !!description && !subtitle,
                    [style$G.onlyTitle]: !!title && !description && !subtitle,
                    [style$G.subtitleDescription]: !!description && !!subtitle,
                }), id: `${id}-content-colorBlock` },
                title && !description && !subtitle && (React.createElement(Typography, { className: style$G.removeTitleBar, color: titleColor, underline: underline, variant: "h1" }, title)),
                subtitle && (React.createElement(Typography, { className: style$G.smallSubtitle, color: "white", variant: "para-small" }, subtitle)),
                showDividerInColorBlock && (React.createElement("div", { className: style$G.titleDivider })),
                title && subtitle && (React.createElement(Typography, { className: classNames(style$G.intro, style$G.introTitle), color: "white", variant: "h1" }, title)),
                description && !title && (React.createElement(Typography, { className: style$G.intro, color: "white", variant: "h1" }, description)),
                description && title && !subtitle && (React.createElement(Typography, { className: style$G.descriptionForTitle, color: "white", removeMargin: true, variant: "para-intro" }, description))))));
};

var style$F = {"heroCarousel":"style-module_heroCarousel__Sz2dl","imageWrapper":"style-module_imageWrapper__6iPII","content":"style-module_content__lsit0","container":"style-module_container__Bobpo","innerBody":"style-module_innerBody__VWuLO","counter":"style-module_counter__aUYv1","divider":"style-module_divider__l03Jy","active":"style-module_active__nUmAY","carouselBody":"style-module_carouselBody__Pktz9","info":"style-module_info__oe226","category":"style-module_category__QdLvG","date":"style-module_date__YYP9g","heroContent":"style-module_heroContent__kIU3P","copy":"style-module_copy__s7Y3c","link":"style-module_link__LBjIT","title":"style-module_title__uCe6M","controls":"style-module_controls__rUDdf"};

const HeroContent = ({ LinkComponent, title, description, date, icon, category, destination, ctaLabel, }) => {
    var _a, _b;
    return (React.createElement("div", { className: style$F.carouselBody },
        React.createElement("div", { className: style$F.info },
            category && (React.createElement("div", { className: style$F.category },
                icon && (React.createElement(Icon, { className: style$F.icon, color: "white", name: icon, size: 14 })),
                React.createElement(Typography, { color: "white", removeMargin: true, variant: "h6" }, category))),
            React.createElement(Typography, { className: style$F.date, color: "white", removeMargin: true, variant: "h6" }, date)),
        React.createElement("div", { className: style$F.heroContent },
            React.createElement("div", { className: style$F.copy },
                title && destination && (React.createElement(Link, { Component: LinkComponent, className: style$F.link, destination: destination }, React.cloneElement(title, {
                    className: style$F.title,
                    options: {
                        ...(((_a = title.props) === null || _a === void 0 ? void 0 : _a.options) || {}),
                        variant: "para-intro",
                        family: "stix",
                        removeMargin: true,
                        color: "white",
                        className: style$F.title,
                    },
                }))),
                description &&
                    React.cloneElement(description, {
                        options: {
                            ...(((_b = description.props) === null || _b === void 0 ? void 0 : _b.options) || {}),
                            removeMargin: true,
                            variant: "para",
                            color: "white",
                        },
                    })),
            destination && ctaLabel && (React.createElement(CTA, { "aria-hidden": "true", color: "main", href: destination, tabIndex: -1, variant: "inverted" }, ctaLabel)))));
};
const HeroCarousel = ({ heroes, LinkComponent, wrapperClassName, contentClassName, }) => {
    const { hovering, ...hoverHandlers } = useHovering();
    const lastIndex = heroes.length - 1;
    const { activeIndex, setActiveIndex, scroll } = useCarouselControls({
        lastIndex,
        infinite: true,
        autoPlay: true,
        hovering,
    });
    const handleDivider = (i) => {
        if (i !== activeIndex)
            setActiveIndex(i);
    };
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => scroll(1),
        onSwipedRight: () => scroll(-1),
    });
    return (React.createElement("div", { ...swipeHandlers, className: classNames(style$F.heroCarousel, wrapperClassName), ...hoverHandlers },
        React.createElement(CarouselBody, { activeIndex: activeIndex, className: "noItemPadding", items: heroes.map(hero => (React.createElement("div", { className: style$F.imageWrapper, key: hero.id }, hero.image))), noGutter: true }),
        React.createElement("div", { className: classNames(style$F.content, contentClassName) },
            React.createElement(Container, { className: classNames(style$F.container, "g-0") },
                React.createElement("div", { className: style$F.innerBody },
                    React.createElement("div", { className: style$F.counter }, heroes.map(({ id }, i) => (React.createElement("button", { "aria-hidden": "true", className: classNames(style$F.divider, {
                            [style$F.active]: i === activeIndex,
                        }), key: id, onClick: () => handleDivider(i), role: "button", tabIndex: -1 })))),
                    React.createElement(CarouselBody, { activeIndex: activeIndex, items: heroes.map(hero => (React.createElement(HeroContent, { ...hero, LinkComponent: LinkComponent, key: hero.id }))), noGutter: true }),
                    activeIndex <= lastIndex && (React.createElement("div", { className: style$F.controls },
                        React.createElement(CarouselButton, { clickHandler: () => scroll(-1), iconColor: "main" }),
                        React.createElement(CarouselButton, { clickHandler: () => scroll(1), flipped: true, iconColor: "main" }))))))));
};

var style$E = {"highlightedArticle":"style-module_highlightedArticle__pTodh","imageWrapper":"style-module_imageWrapper__JLJZp","contentWrapper":"style-module_contentWrapper__Cd5C5","date":"style-module_date__CHnu3","title":"style-module_title__XAOl4","description":"style-module_description__zYR1W","imageRight":"style-module_imageRight__Q8SCb","content":"style-module_content__-7m7f"};

const HighlightedArticle = ({ id = "HighlightedArticle", imageLeft = true, Image, date, title, description, callToAction, isAngle, className, }) => (React.createElement("div", { className: classNames(style$E.highlightedArticle, {
        [style$E.imageRight]: !imageLeft,
    }, className), id: id },
    React.createElement("div", { className: style$E.imageWrapper }, Image),
    React.createElement("div", { className: style$E.contentWrapper },
        React.createElement("div", { className: style$E.content },
            date && (React.createElement(Typography, { className: style$E.date, color: "primary", variant: "subtitle-small" }, date)),
            title &&
                React.cloneElement(title, {
                    className: style$E.title,
                    options: { variant: "para-intro" },
                }),
            isAngle && description && (React.createElement(Typography, { className: style$E.description, variant: "para" }, description)),
            callToAction))));

var style$D = {"hrInfoCard":"style-module_hrInfoCard__-t-N3","number":"style-module_number__7khrw","lastChildNoMargin":"style-module_lastChildNoMargin__aQrlI"};

const HrInfoCard = React.forwardRef(({ number, title, content, id, titleMargin, numberMargin }, ref) => {
    var _a;
    const theme = React.useContext(ThemeContext);
    return (React.createElement("div", { className: style$D.hrInfoCard, id: id, ref: ref },
        React.createElement("div", { style: { marginBottom: numberMargin } },
            React.createElement(Typography, { className: style$D.number, color: theme !== "primary" ? "primary" : "white", removeMargin: true, variant: "subtitle" }, number)),
        React.createElement("div", { style: { marginBottom: titleMargin } },
            React.createElement(Typography, { color: theme !== "primary" ? "primary" : "white", component: "p", variant: "h4" }, title)),
        content &&
            React.cloneElement(content, {
                className: ((_a = content === null || content === void 0 ? void 0 : content.props) === null || _a === void 0 ? void 0 : _a.className)
                    ? `${content === null || content === void 0 ? void 0 : content.props.className} ${style$D.lastChildNoMargin}`
                    : style$D.lastChildNoMargin,
            })));
});
HrInfoCard.displayName = "HrInfoCard";

var style$C = {"iconNumberCard":"style-module_iconNumberCard__l-87c","white":"style-module_white__ZMFRR","primary":"style-module_primary__gfXGN","content":"style-module_content__lJz5V","label":"style-module_label__GyGfA","gray":"style-module_gray__0MJ-M","noMargin":"style-module_noMargin__RKjL-"};

const IconNumberCard = ({ icon, number, image, children, className, noMargin, }) => {
    const containerBackground = useContext(ThemeContext);
    const backgroundMapping = {
        white: "gray",
        gray: "white",
        primary: "white",
        main: "white",
        trustedBlue: "white",
    };
    const labelMapping = {
        white: "primary",
        gray: "primary",
        primary: "gray",
        main: "gray",
        trustedBlue: "white",
    };
    const cardBackground = backgroundMapping[containerBackground];
    const labelBackground = labelMapping[containerBackground];
    return (React.createElement("div", { className: classNames(className, style$C.iconNumberCard, style$C[cardBackground], {
            [style$C.noMargin]: noMargin,
        }) },
        React.createElement("div", { className: classNames(style$C.label, style$C[labelBackground]) }, icon ? (React.createElement(Icon, { color: "white", name: icon, size: 35 })) : image ? (image) : (number)),
        React.createElement("div", { className: style$C.content },
            React.createElement(ThemeContext.Provider, { value: cardBackground }, children))));
};

var style$B = {"imageWithOverlay":"style-module_imageWithOverlay__NSY-G","imageWrapper":"style-module_imageWrapper__J7PRg","content":"style-module_content__ai45k","primary":"style-module_primary__eLASl","gray":"style-module_gray__xsNhQ","hrVariant":"style-module_hrVariant__9cK7n","ctaVariant":"style-module_ctaVariant__5bkNw"};

const ImageSectionWithOverlay = ({ image, id, children, background = "white", variant = "HR", }) => (React.createElement("section", { className: classNames(style$B.imageWithOverlay, style$B[`${variant.toLowerCase()}Variant`]), id: id },
    image &&
        React.cloneElement(image, {
            className: style$B.imageWrapper,
            id: `${id}-image`,
        }),
    React.createElement("div", { className: classNames(style$B.content, style$B[background]), id: `${id}-content` },
        React.createElement(ThemeContext.Provider, { value: background }, children))));

var style$A = {"jobcard":"style-module_jobcard__kGZfF","location":"style-module_location__Wuvfv","title":"style-module_title__OE2-1","action":"style-module_action__MM0xK","icon":"style-module_icon__CmDmC"};

const Jobcard = ({ location, icon = "other", title, url, actionLabel, }) => (React.createElement("div", { className: style$A.jobcard },
    React.createElement("div", { className: `${style$A.icon} icon-${icon}` }),
    React.createElement("div", { className: style$A.location }, location),
    React.createElement("div", { className: style$A.title }, title),
    React.createElement("div", { className: style$A.action },
        React.createElement(CallToAction, { href: url, openInNewTab: true, type: "text" }, actionLabel))));

var style$z = {"label":"style-module_label__VbIRv"};

const Label = ({ className, children, ...props }) => (React.createElement(Label$1, { className: classNames(className, style$z.label), ...props }, children));

var style$y = {"latestArticlesSection":"style-module_latestArticlesSection__VYUN1","mainArticleContainer":"style-module_mainArticleContainer__cJ-q7","image":"style-module_image__lpQeE","mainArticleInfo":"style-module_mainArticleInfo__HYxZa","title":"style-module_title__xplIp","date":"style-module_date__-23mn","icon":"style-module_icon__jcA7R","contentContainer":"style-module_contentContainer__Ug3p9","content":"style-module_content__gowRl","article":"style-module_article__Yox8F","cta":"style-module_cta__zTJIf","mainArticleContent":"style-module_mainArticleContent__RDv4y"};

const px2rem$1 = (n) => n / 16;
const getColumnHeight = (element) => {
    const style = window.getComputedStyle(element);
    const minH = 600;
    let height = element.offsetHeight;
    for (const side of ["top", "bottom"])
        height += parseInt(style[`margin-${side}`]);
    if (height < minH)
        return px2rem$1(minH);
    return px2rem$1(height);
};
const LatestArticlesSection = ({ firstArticle, latestArticles, title, cta, }) => {
    const isDesktop = useMediaQuery();
    const [imageH, setImageH] = useState(0);
    const rightColumn = useRef(null);
    useEffect(() => {
        if (rightColumn.current) {
            const mobileH = 276;
            let h = 0;
            if (isDesktop)
                h = getColumnHeight(rightColumn.current);
            else
                h = px2rem$1(mobileH);
            setImageH(h);
        }
    }, [isDesktop]);
    return (React.createElement(Row, { className: style$y.latestArticlesSection, noGutters: true, tag: "section" },
        React.createElement(Col, { className: classNames("g-0", style$y.mainArticleContainer), md: 6 },
            React.createElement("div", { className: style$y.image, style: { height: `${imageH}rem` } }, firstArticle.image),
            React.createElement("div", { className: style$y.mainArticleInfo },
                React.createElement("div", { className: style$y.mainArticleContent },
                    React.createElement(Typography, { className: style$y.date, color: "white", removeMargin: true, variant: "h6" },
                        firstArticle.icon && (React.createElement(Icon, { className: style$y.icon, color: "white", name: firstArticle.icon, size: 14 })),
                        firstArticle.date),
                    React.cloneElement(firstArticle.title, {
                        className: style$y.title,
                    })))),
        React.createElement(Col, { className: style$y.contentContainer, md: 6 },
            React.createElement("div", { className: style$y.content, ref: rightColumn },
                title,
                latestArticles.map((article, i) => (React.createElement("div", { className: style$y.article, key: i },
                    React.createElement(Typography, { className: style$y.date, color: "primary", removeMargin: true, variant: "h6" },
                        article.icon && (React.createElement(Icon, { className: style$y.icon, name: article.icon, size: 14 })),
                        article.date),
                    React.cloneElement(article.title, {
                        className: style$y.title,
                    })))),
                cta &&
                    React.cloneElement(cta, {
                        className: style$y.cta,
                        variant: "outlined",
                    })))));
};

var style$x = {"list":"style-module_list__GbjDU","listColumn":"style-module_listColumn__W2zVp","listItem":"style-module_listItem__VscgL","complex":"style-module_complex__Y0UQd","complexContent":"style-module_complexContent__gsFg1","icon":"style-module_icon__uWSwp","olPrefix":"style-module_olPrefix__nJie2","showBullets":"style-module_showBullets__6ngmF","primary":"style-module_primary__zbeV5","nestedList":"style-module_nestedList__319bz","multipleColumns":"style-module_multipleColumns__0V2GN","nestedColumn":"style-module_nestedColumn__sBadb"};

const getMiddleIndex = (items) => Math.ceil(items.length / 2);
const divideList = (items, even) => {
    const middleIndex = getMiddleIndex(items);
    return even ? items.slice(0, middleIndex) : items.slice(middleIndex);
};
const UlPrefix = ({ icon }) => icon ? (React.createElement(Icon, { className: style$x.icon, color: "primary", name: icon, size: 22 })) : null;
const OlPrefix = ({ index }) => {
    const formattedIndex = index < 10 ? `0${index}` : index;
    return (React.createElement("div", { className: style$x.olPrefix },
        React.createElement(Typography, { removeMargin: true, variant: "ol-prefix" }, formattedIndex)));
};
const ListItems = ({ items, icon, startIndex = 0, type = "ul", nested = false, singleList, }) => (React.createElement("div", { className: classNames(style$x.listColumn, {
        [style$x.nestedColumn]: nested,
        [style$x.multipleColumns]: !singleList,
    }) }, items.map((item, i) => {
    const isComplex = (item === null || item === void 0 ? void 0 : item.type) !== Typography &&
        (item === null || item === void 0 ? void 0 : item.type) !== "string" &&
        typeof item !== "string";
    return (React.createElement("li", { className: classNames(style$x.listItem, {
            [style$x.complex]: isComplex,
        }), key: nested ? `nested-${type}-${i}` : `${type}-${i}` },
        type === "ul" && React.createElement(UlPrefix, { icon: icon }),
        type === "ol" && React.createElement(OlPrefix, { index: i + 1 + startIndex }),
        isComplex ? (React.createElement("div", { className: style$x.complexContent }, item)) : (item)));
})));
const ListColumns = ({ items, icon, type = "ul", nested }) => items.length < 6 ? (React.createElement(ListItems, { icon: icon, items: items, nested: nested, singleList: true, type: type })) : (React.createElement(React.Fragment, null,
    React.createElement(ListItems, { icon: icon, items: divideList(items, true), nested: nested, type: type }),
    React.createElement(ListItems, { icon: icon, items: divideList(items, false), nested: nested, startIndex: getMiddleIndex(items), type: type })));
const List = ({ items, icon, type: Tag = "ul", nested = false }) => {
    const backgroundColor = useContext(ThemeContext);
    const listTheme = ["white", "gray"].includes(backgroundColor)
        ? "primary"
        : "white";
    return (React.createElement(Tag, { className: classNames(style$x.list, style$x[listTheme], !icon && style$x.showBullets, nested && style$x.nestedList) },
        React.createElement(ListColumns, { icon: icon, items: items, nested: nested, type: Tag })));
};

var style$w = {"buttonContainer":"style-module_buttonContainer__vFhKh"};

const ListViewToggle = ({ active = "card", onClick, imageViewIcon = "image-view", listViewIcon = "list-view", className, }) => (React.createElement("div", { className: classNames(style$w.buttonContainer, className) },
    React.createElement(Button, { "aria-label": "view as card grid", iconFont: imageViewIcon, iconSize: 23, onClick: () => onClick("card"), variant: active === "card" ? "filled" : "outlined" }),
    React.createElement(Button, { "aria-label": "view as list", iconFont: listViewIcon, iconSize: 23, onClick: () => onClick("list"), variant: active === "list" ? "filled" : "outlined" })));

const MenuThemeContext = createContext("Primary");

var style$v = {"navigationMinorActionButton":"style-module_navigationMinorActionButton__sUdwq","label":"style-module_label__nzOhP","minorActionItems":"style-module_minorActionItems__iXWbv","desktop":"style-module_desktop__QprqZ"};

const NavigationMinorActionButton = ({ icon, label, action, destination, color, linkComponent, testId, }) => {
    if (action)
        return (React.createElement("button", { className: classNames(style$v.navigationMinorActionButton, style$v[color]), "data-testid": testId, onClick: action, type: "button" },
            React.createElement(Icon, { color: color, name: icon, size: 10 }),
            React.createElement(Typography, { className: style$v.label, color: color }, label)));
    if (destination)
        return (React.createElement(Link, { Component: linkComponent, className: style$v.navigationMinorActionButton, destination: destination },
            React.createElement(Icon, { color: color, name: icon, size: 10 }),
            React.createElement(Typography, { className: style$v.label, color: color }, label)));
    return null;
};
const NavigationMinorActions = ({ items, linkComponent, desktop = false, color, }) => (React.createElement("div", { className: classNames(style$v.minorActionItems, desktop && style$v.desktop) }, isArrayWithContent(items) &&
    items.map((item, i) => (React.createElement(NavigationMinorActionButton, { color: color, key: `minorAction-${i}`, linkComponent: linkComponent, ...item })))));

var style$u = {"navigationPrimaryActionButton":"style-module_navigationPrimaryActionButton__xWhAK","inverted":"style-module_inverted__1XgHG","mobile":"style-module_mobile__na-HI","primaryActionItems":"style-module_primaryActionItems__Le53y","searchButton":"style-module_searchButton__Uwqzx"};

const NavigationPrimaryActionButton = ({ label, destination, inverted, linkComponent, mobile, className, }) => {
    if (destination)
        return (React.createElement(Link, { Component: linkComponent, className: classNames(className, style$u.navigationPrimaryActionButton, inverted && style$u.inverted, mobile && style$u.mobile), destination: destination }, label));
    return null;
};
const NavigationPrimaryActions = ({ items, linkComponent, inverted, mobile, onSearch, searchButtonLabel = "Open search bar", }) => (React.createElement("div", { className: classNames(style$u.primaryActionItems, mobile && style$u.mobile) },
    isArrayWithContent(items) &&
        items.map((item, i) => (React.createElement(NavigationPrimaryActionButton, { inverted: inverted, key: `minorAction-${i}`, linkComponent: linkComponent, ...item, mobile: mobile }))),
    onSearch && (React.createElement(Button, { "aria-label": searchButtonLabel, className: classNames(style$u.searchButton, {
            [style$u.inverted]: inverted,
        }), iconColor: "white", iconName: "search", iconSize: mobile ? 22 : 30, name: searchButtonLabel, onClick: onSearch, variant: "icon" }))));

var style$t = {"collapse":"style-module_collapse__XJhZL","mobileMenu":"style-module_mobileMenu__7EPWA","mainLinks":"style-module_mainLinks__21n89","link":"style-module_link__xNrR7","icon":"style-module_icon__pixjQ","subLinks":"style-module_subLinks__bH1Cd","header":"style-module_header__kZQIC","category":"style-module_category__OwJEL","category__title":"style-module_category__title__mTWTS","links":"style-module_links__KfNDX","columnTitle":"style-module_columnTitle__TJkst","primaryGreen":"style-module_primaryGreen__0q2-A","sustainableGreen":"style-module_sustainableGreen__8yHrl","fundamentalGreen":"style-module_fundamentalGreen__PlXF0","multiBlue":"style-module_multiBlue__pc3TV","fixedBlue":"style-module_fixedBlue__14iZA","quantitativeRed":"style-module_quantitativeRed__VeHiI","main":"style-module_main__oxW2e"};

const MainLinks = ({ items, linkComponent, onSetActiveItem: setActiveItem, }) => (React.createElement("div", { className: style$t.mainLinks },
    React.createElement("ul", null, items.map((menuItem, index) => {
        var _a;
        return (React.createElement("li", { key: index }, ((_a = menuItem.subMenuItems) === null || _a === void 0 ? void 0 : _a.length) ? (React.createElement("button", { className: style$t.link, onClick: () => setActiveItem(menuItem) },
            menuItem.label,
            React.createElement(Icon, { className: style$t.icon, color: "main", name: "chevron", size: 27 }))) : (React.createElement(Link, { Component: linkComponent, className: style$t.link, destination: "" }, menuItem.label))));
    }))));
const SubLinks = ({ menuItem, onSetActiveItem: setActiveItem, goBackLabel, linkComponent, switchInvestorBtn, }) => {
    var _a;
    return (React.createElement("div", { className: classNames(style$t.subLinks, menuItem.theme && style$t[camelcase(menuItem.theme)]) },
        React.createElement("div", { className: style$t.header },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 4 },
                    React.createElement("button", { onClick: () => setActiveItem() },
                        React.createElement(Icon, { className: style$t.icon, color: "darkGrey", name: "arrowLeft" }),
                        goBackLabel || "Back")),
                React.createElement(Col, null, menuItem.label))),
        React.createElement("div", null, (_a = menuItem.subMenuItems) === null || _a === void 0 ? void 0 : _a.map((submenuItem, index) => {
            var _a;
            return !submenuItem.text &&
                !submenuItem.hideOnMobile && (React.createElement("div", { className: style$t.category, key: index },
                React.createElement("div", { className: style$t.category__title }, submenuItem.title), (_a = submenuItem === null || submenuItem === void 0 ? void 0 : submenuItem.menuColumns) === null || _a === void 0 ? void 0 :
                _a.map((menuColumn, index) => {
                    var _a;
                    return (React.createElement("div", { className: style$t.links, key: index },
                        React.createElement("div", { className: style$t.columnTitle }, menuColumn.title),
                        React.createElement("ul", null, (_a = menuColumn.links) === null || _a === void 0 ? void 0 : _a.map((link, index) => (React.createElement("li", { key: index },
                            React.createElement(Link, { Component: linkComponent, className: style$t.link, destination: link.location ||
                                    "" }, link.label)))))));
                }),
                menuItem.subMenuItems &&
                    index === menuItem.subMenuItems.length - 1 &&
                    switchInvestorBtn &&
                    switchInvestorBtn));
        }))));
};
const MobileMenu = ({ open, menuItems, linkComponent, goBackLabel, className, minorActionItems, primaryActionItems, switchInvestorBtn, }) => {
    const [activeItem, setActiveItem] = useState();
    return (React.createElement(Collapse, { className: classNames(style$t.collapse, className), "data-testid": "mobile-menu", isOpen: open, onExited: () => setActiveItem(null) },
        React.createElement("div", { className: style$t.mobileMenu },
            !activeItem ? (React.createElement(MainLinks, { items: menuItems, linkComponent: linkComponent, onSetActiveItem: setActiveItem })) : (React.createElement(SubLinks, { goBackLabel: goBackLabel, linkComponent: linkComponent, menuItem: activeItem, onSetActiveItem: setActiveItem, switchInvestorBtn: switchInvestorBtn })),
            React.createElement(NavigationMinorActions, { color: "darkGrey", items: minorActionItems, linkComponent: linkComponent }),
            React.createElement(NavigationPrimaryActions, { inverted: true, items: primaryActionItems, linkComponent: linkComponent, mobile: true }))));
};

var style$s = {"subNavigation":"style-module_subNavigation__JjpYK","category":"style-module_category__5aRXd","container":"style-module_container__AHgic","innerContent":"style-module_innerContent__HaHPl","innerContent__active":"style-module_innerContent__active__X7sPA","menuHeaders":"style-module_menuHeaders__DT4Y4","textColumn":"style-module_textColumn__Cn5eh","icon":"style-module_icon__5M6wg","linkColumn":"style-module_linkColumn__NB1De","linkColumn__title":"style-module_linkColumn__title__RVRdx","primaryGreen":"style-module_primaryGreen__qAyaU","sustainableGreen":"style-module_sustainableGreen__yowXW","fundamentalGreen":"style-module_fundamentalGreen__ZXezJ","multiBlue":"style-module_multiBlue__58KrK","fixedBlue":"style-module_fixedBlue__2-fd9","quantitativeRed":"style-module_quantitativeRed__ag0ss","main":"style-module_main__W--Ft","linkWrapper":"style-module_linkWrapper__dvUlo","clickableText":"style-module_clickableText__EheHF"};

const getColumnSize = (items) => {
    if (!items)
        return 3;
    const total = items.reduce((sum, { menuColumns, text }) => {
        if (text || !(menuColumns === null || menuColumns === void 0 ? void 0 : menuColumns.length))
            return (sum += 1);
        return (sum += menuColumns.length);
    }, 0);
    return total ? Math.max(12 / total, 3) : 3;
};
const LinkColumns = ({ columns, linkComponent, switchInvestorBtn, columnSize, }) => {
    const menuTheme = useContext(MenuThemeContext);
    const titleColorStyle = camelcase(menuTheme);
    return (React.createElement(React.Fragment, null, columns === null || columns === void 0 ? void 0 : columns.map((column, index) => {
        var _a;
        const Cta = column.cta;
        return (React.createElement(Col, { className: style$s.linkColumn, key: index, md: columnSize || 3 },
            React.createElement("div", { className: classNames(style$s.linkColumn__title, style$s[titleColorStyle]) }, column.title),
            React.createElement("ul", null, (_a = column.links) === null || _a === void 0 ? void 0 : _a.map((link, index) => (React.createElement("li", { key: index },
                React.createElement("div", { className: style$s.linkWrapper },
                    React.createElement(Link, { Component: linkComponent, className: style$s.clickableText, destination: link.location }, link.label),
                    React.createElement(Icon, { className: style$s.icon, name: "chevron", size: 16 })))))),
            Cta && React.createElement("div", null, Cta),
            index === columns.length - 1 &&
                switchInvestorBtn &&
                switchInvestorBtn));
    })));
};
const SubNavigation = ({ modShow, menuItems, onMouseOut: handleMouseOut, linkComponent, switchInvestorBtn, active = false, }) => (React.createElement("div", { className: classNames(style$s.subNavigation) },
    React.createElement(Collapse, { isOpen: modShow && active },
        React.createElement(Container, { className: style$s.container, fluid: true, id: "subNavigation", onMouseLeave: handleMouseOut },
            React.createElement("div", { className: classNames(style$s.innerContent, modShow && style$s.innerContent__active) },
                React.createElement(Row, { className: style$s.menuHeaders }, menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(({ title, menuColumns, text }, index, items) => {
                    const columnSize = getColumnSize(items);
                    return (React.createElement(Col, { className: style$s.category, key: index, md: text
                            ? 3
                            : ((menuColumns === null || menuColumns === void 0 ? void 0 : menuColumns.length) || 1) *
                                columnSize }, title));
                })),
                React.createElement(Row, null, menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(({ menuColumns, text }, index, items) => {
                    const columnSize = getColumnSize(items);
                    return text || !(menuColumns === null || menuColumns === void 0 ? void 0 : menuColumns.length) ? (React.createElement(Col, { className: style$s.textColumn, key: index, md: 3 }, text)) : (React.createElement(LinkColumns, { columnSize: columnSize, columns: menuColumns, key: index, linkComponent: linkComponent, switchInvestorBtn: index === items.length - 1 &&
                            switchInvestorBtn }));
                })))))));

var style$r = {"navBar":"style-module_navBar__-Cuzq","navBar__inverted":"style-module_navBar__inverted__FVwGM","active":"style-module_active__daRhI","hoverActive":"style-module_hoverActive__hT8N5","listItem":"style-module_listItem__M987k","listItem__inverted":"style-module_listItem__inverted__5p--v","mobileNavigation":"style-module_mobileNavigation__OJ2g2","withSearch":"style-module_withSearch__CI4q-","mobileNavigation__content":"style-module_mobileNavigation__content__B8D-e","search":"style-module_search__urtS0","mobileNavigation__content-inverted":"style-module_mobileNavigation__content-inverted__gQ4Kk","mobileNavigation__content-open":"style-module_mobileNavigation__content-open__y7PQ0"};

const NavBar = ({ menuItems, inverted, linkComponent, onMouseOver: handleMouseOver, onMouseOut: handleMouseOut, activeMenuItem, open, onToggle: handleToggle, onSearch: handleSearch, searchButtonLabel = "Open search bar", switchInvestorBtn, }) => (React.createElement(React.Fragment, null,
    React.createElement("ul", { className: classNames("d-none d-lg-flex", style$r.navBar, inverted && style$r.navBar__inverted), id: "subnavbar" }, menuItems === null || menuItems === void 0 ? void 0 : menuItems.map((menuItem, index) => (React.createElement("li", { key: index },
        React.createElement("div", { className: style$r.listItem },
            React.createElement(Link, { Component: linkComponent, "aria-haspopup": "true", className: (activeMenuItem === null || activeMenuItem === void 0 ? void 0 : activeMenuItem.label) === menuItem.label &&
                    style$r.hoverActive, destination: "", id: menuItem.label, onClick: () => handleMouseOver(index), onFocus: () => handleMouseOver(index), onKeyDown: e => {
                    if (e.key === "Enter") {
                        handleMouseOver(index);
                    }
                }, onMouseOut: handleMouseOut, onMouseOver: () => {
                    handleMouseOver(index);
                } }, menuItem.label)),
        React.createElement(SubNavigation, { active: (activeMenuItem === null || activeMenuItem === void 0 ? void 0 : activeMenuItem.label) === menuItem.label, linkComponent: linkComponent, menuItems: menuItem === null || menuItem === void 0 ? void 0 : menuItem.subMenuItems, modShow: !!activeMenuItem && !!(activeMenuItem === null || activeMenuItem === void 0 ? void 0 : activeMenuItem.subMenuItems), onMouseOut: handleMouseOut, switchInvestorBtn: switchInvestorBtn }))))),
    React.createElement("div", { className: classNames("d-lg-none", style$r.mobileNavigation, {
            [style$r.withSearch]: handleSearch,
        }) },
        React.createElement("div", { className: classNames(style$r.mobileNavigation__content, {
                [style$r["mobileNavigation__content-inverted"]]: inverted || open,
                [style$r["mobileNavigation__content-open"]]: open,
            }) },
            handleSearch && (React.createElement(Button, { "aria-label": searchButtonLabel, className: style$r.search, iconName: "search", iconSize: 40, name: searchButtonLabel, onClick: handleSearch, variant: "icon" })),
            React.createElement(Hamburger, { inverted: inverted || open, onToggle: handleToggle, open: open })))));

var style$q = {"mainNavigation":"style-module_mainNavigation__Ey-y1","mainNavigation__inverted":"style-module_mainNavigation__inverted__Ka7um","overlay":"style-module_overlay__wZDak","overlay__hidden":"style-module_overlay__hidden__n8Y03","mobileDivider":"style-module_mobileDivider__V4EUF","nav":"style-module_nav__havK1","nav__inner":"style-module_nav__inner__VmX3b","logo":"style-module_logo__xlBjl","secondaryArea":"style-module_secondaryArea__7zuXG"};

const includesParentByClass = (element, classNames) => {
    if (!element) {
        return;
    }
    let parent = element.parentElement;
    while (parent) {
        if (classNames.includes(parent.className)) {
            return true;
        }
        parent = parent.parentElement;
    }
    return false;
};
const MainNavigation = ({ activeMenuItem, className, goBackLabel, inverted, linkComponent, logo, menuItems, minorActionItems, onSearch, primaryActionItems, searchButtonLabel, setActiveMenuItem, setShowMobileMenu, showMobileMenu = false, switchInvestorBtn, }) => {
    const wrappedMinorActions = useMemo(() => minorActionItems &&
        minorActionItems.map(el => {
            if (!el.action)
                return el;
            else
                return {
                    ...el,
                    action: () => {
                        el.action && el.action();
                        setShowMobileMenu(false);
                    },
                };
        }), [minorActionItems, setShowMobileMenu]);
    const wrappedOnSearch = useMemo(() => onSearch
        ? (ev) => {
            // the state update is faster than the click event bubbling
            // without this the clickoutside of the search is triggered
            // closing it immediately if the mobile menu is open
            ev.stopPropagation();
            setShowMobileMenu(false);
            onSearch && onSearch();
        }
        : undefined, [onSearch, setShowMobileMenu]);
    useEffect(() => {
        document.body.style.overflow = showMobileMenu ? "hidden" : "unset";
    }, [showMobileMenu]);
    const handleMouseOut = (event) => {
        const element = event === null || event === void 0 ? void 0 : event.currentTarget;
        if (!includesParentByClass(element, ["subNavigation", "navbar"]) &&
            (activeMenuItem === null || activeMenuItem === void 0 ? void 0 : activeMenuItem.label) !== (element === null || element === void 0 ? void 0 : element.id)) {
            setActiveMenuItem(undefined);
        }
    };
    return (React.createElement("div", { className: classNames("align-items-center", style$q.mainNavigation, inverted && style$q.mainNavigation__inverted, className) },
        React.createElement(MenuThemeContext.Provider, { value: (activeMenuItem === null || activeMenuItem === void 0 ? void 0 : activeMenuItem.theme) || "Primary" },
            React.createElement("nav", { "aria-label": "main navigation", className: classNames("navbar", style$q.nav) },
                React.createElement(Container, { className: classNames("flex-nowrap", style$q.nav__inner), fluid: true, id: "navbar" },
                    React.createElement("div", { className: "d-flex align-items-center justify-content-start" },
                        logo && (React.createElement("div", { className: classNames("navbar-brand", style$q.logo) }, logo)),
                        React.createElement(NavBar, { activeMenuItem: activeMenuItem, inverted: inverted, linkComponent: linkComponent, menuItems: menuItems, onMouseOut: handleMouseOut, onMouseOver: index => setActiveMenuItem(index || index === 0
                                ? menuItems[index]
                                : undefined), onSearch: wrappedOnSearch, onToggle: () => setShowMobileMenu(!showMobileMenu), open: showMobileMenu, searchButtonLabel: searchButtonLabel, switchInvestorBtn: switchInvestorBtn })),
                    React.createElement("div", { className: classNames("d-none d-lg-flex", style$q.secondaryArea) },
                        React.createElement(NavigationMinorActions, { color: inverted ? "darkGrey" : "white", desktop: true, items: wrappedMinorActions, linkComponent: linkComponent }),
                        React.createElement(NavigationPrimaryActions, { desktop: true, inverted: inverted, items: primaryActionItems, linkComponent: linkComponent, onSearch: onSearch, searchButtonLabel: searchButtonLabel })),
                    React.createElement("div", { className: classNames("d-lg-none", style$q.overlay, !showMobileMenu && style$q.overlay__hidden) })),
                React.createElement(MobileMenu, { className: "d-lg-none", goBackLabel: goBackLabel, linkComponent: linkComponent, menuItems: menuItems, minorActionItems: wrappedMinorActions, open: showMobileMenu, primaryActionItems: primaryActionItems, switchInvestorBtn: switchInvestorBtn }),
                !inverted && (React.createElement("div", { className: classNames(style$q.mobileDivider, "d-lg-none") }))))));
};

var style$p = {"mediaGrid":"style-module_mediaGrid__V18-B","mediaWrapper":"style-module_mediaWrapper__Dmsq-","media0":"style-module_media0__5ojVv","media1":"style-module_media1__C9aNy","media2":"style-module_media2__XIhGC","media3":"style-module_media3__boPYc"};

const MediaGrid = ({ id = "MediaGrid", media, className }) => (React.createElement("section", { className: classNames(className, style$p.mediaGrid), id: id }, media === null || media === void 0 ? void 0 : media.map((entry, index) => {
    const key = `${id}-${index}-image-wrapper`;
    return (React.createElement("div", { className: classNames(style$p.mediaWrapper, style$p[`media${index}`]), id: key, key: key }, entry));
})));

var style$o = {"modal":"style-module_modal__oB5bh","header":"style-module_header__C9EmL","body":"style-module_body__dkVzY","noHeader":"style-module_noHeader__0acdn","icon":"style-module_icon__xSBGF","footer":"style-module_footer__wFfuY","confirmButton":"style-module_confirmButton__MsSrU"};

const Modal = ({ id, children, isOpen, closeAriaLabel, size = "lg", primaryButton, secondaryButton, onClose, closable = true, icon, testId, }) => (React.createElement(Modal$1, { backdrop: !closable && "static", centered: true, contentClassName: style$o.modal, "data-testid": testId, id: id, isOpen: isOpen, scrollable: true, size: size, toggle: onClose },
    closable && (React.createElement(ModalHeader, { className: style$o.header, closeAriaLabel: closeAriaLabel, id: `${id || "randomModal"}-header`, toggle: onClose })),
    React.createElement(ModalBody, { className: classNames(style$o.body, !closable && style$o.noHeader), id: `${id || "randomModal"}-body` },
        icon && React.createElement("div", { className: style$o.icon }, icon),
        children),
    (primaryButton || secondaryButton) && (React.createElement(ModalFooter, { className: style$o.footer, id: `${id || "randomModal"}-footer` },
        secondaryButton && (React.createElement(CTA, { disabled: secondaryButton.disabled, fullWidth: true, id: `${id || "randomModal"}-secondaryButton`, onClick: secondaryButton.onClick, variant: "outlined" }, secondaryButton.label)),
        primaryButton && (React.createElement(CTA, { className: style$o.confirmButton, disabled: primaryButton.disabled, fullWidth: true, id: `${id || "randomModal"}-primaryButton`, onClick: primaryButton.onClick, variant: "filled" }, primaryButton.label))))));

var style$n = {"modal":"style-module_modal__6pthd","modal-content":"style-module_modal-content__OpOAF","body":"style-module_body__ojiiG","closeButton":"style-module_closeButton__VnPp0","container":"style-module_container__PmI9b","leftSideContainer":"style-module_leftSideContainer__5dnUE","icon":"style-module_icon__-awda","title":"style-module_title__SgkNi","rightSideContainer":"style-module_rightSideContainer__Es99i"};

const ModalImage = ({ id, children, isOpen, closeAriaLabel, onClose, closable = true, backgroundImage, title, icon, color = "white", size = "lg", }) => {
    const isDesktop = useMediaQuery(1024);
    const backgroundStyle = backgroundImage
        ? { backgroundImage: `url('${backgroundImage.image.url}')`, color }
        : {};
    return (React.createElement(Modal$1, { backdrop: !closable && "static", centered: true, contentClassName: style$n.modal, id: id, isOpen: isOpen, scrollable: true, size: size, toggle: onClose },
        React.createElement(ModalBody, { className: style$n.body, style: { padding: 0, overflow: "hidden" } },
            React.createElement("button", { "aria-label": closeAriaLabel, className: style$n.closeButton, onClick: onClose, onMouseEnter: e => (e.currentTarget.style.opacity = "0.7"), onMouseLeave: e => (e.currentTarget.style.opacity = "1") },
                React.createElement(Icon, { color: isDesktop ? "main" : "white", name: "closeCircleFill", size: 24 })),
            React.createElement("div", { className: style$n.container },
                (icon || title) && (React.createElement("div", { "aria-label": (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.alt) || "Background image", className: classNames(style$n.leftSideContainer), style: backgroundStyle },
                    icon && React.createElement("div", { className: style$n.icon }, icon),
                    title && React.createElement("h2", { className: style$n.title }, title))),
                React.createElement("div", { className: style$n.rightSideContainer }, children)))));
};

var style$m = {"newsCard":"style-module_newsCard__BZ2aX","image":"style-module_image__iqE7k","content":"style-module_content__4eS9I","heading":"style-module_heading__fR-Dc","articleType":"style-module_articleType__ZByXP","icon":"style-module_icon__O4hfk","text":"style-module_text__wgJl1"};

const NewsCard = ({ image, newsType, newsTypeIcon, publishDate, title, introText, Cta, destination, className, }) => (React.createElement(Container, { className: classNames(style$m.newsCard, className), fluid: "md" },
    React.createElement(Row, { className: style$m.row },
        React.createElement(Col, { className: style$m.image, md: 6 }, image &&
            (destination ? (React.createElement(Link, { className: style$m.link, destination: destination }, image)) : (image))),
        React.createElement(Col, { className: style$m.content, md: 6 },
            React.createElement("div", { className: style$m.heading },
                React.createElement(Typography, { className: style$m.articleType, removeMargin: true, variant: "h6" },
                    newsTypeIcon && (React.createElement(Icon, { className: style$m.icon, color: "primary", name: newsTypeIcon, size: 14 })),
                    React.createElement("span", null, newsType)),
                React.createElement(Typography, { removeMargin: true, variant: "h6" }, publishDate)),
            title &&
                (destination ? (React.createElement(Link, { className: style$m.link, destination: destination }, React.cloneElement(title, {
                    options: {
                        variant: "card-title",
                    },
                }))) : (React.createElement(Typography, { variant: "card-title" }, title))),
            React.createElement(Typography, { className: style$m.text, variant: "para-small" }, introText),
            React.cloneElement(Cta, {
                options: { type: "text" },
            })))));

var style$l = {"numberCard":"style-module_numberCard__-w1rJ","number":"style-module_number__vnEuf","title":"style-module_title__BsSaG","content":"style-module_content__uI58U","inverted":"style-module_inverted__-cFeP"};

const NumberCard = ({ content, number, title }) => {
    const containerBackground = useContext(ThemeContext);
    const inverted = containerBackground === "primary";
    return (React.createElement("div", { className: classNames(style$l.numberCard, inverted && style$l.inverted) },
        React.createElement("div", { className: style$l.number }, number),
        React.createElement("div", { className: style$l.title }, title),
        React.createElement("div", { className: style$l.content }, content)));
};

var style$k = {"wrapper":"style-module_wrapper__9MoRb","image":"style-module_image__pjaVB","fullWidth":"style-module_fullWidth__2A49n","content":"style-module_content__IY4Bk","inverted":"style-module_inverted__HP6YN","white":"style-module_white__-luP9","darkGrey":"style-module_darkGrey__lYUh8","primary":"style-module_primary__qsxaA","midGrey":"style-module_midGrey__sg8D6","lightGrey":"style-module_lightGrey__3Xdl2","lightMidGrey":"style-module_lightMidGrey__XK3yQ","primaryGreen":"style-module_primaryGreen__yd4XL","sustainableGreen":"style-module_sustainableGreen__frx0G","fundamentalGreen":"style-module_fundamentalGreen__SSzef","multiBlue":"style-module_multiBlue__Oj4ae","fixedBlue":"style-module_fixedBlue__y-Vht","quantitativeRed":"style-module_quantitativeRed__V-vLP","trustedBlue":"style-module_trustedBlue__LtKeU","error":"style-module_error__90e9D","main":"style-module_main__O01Ab","highlightRight":"style-module_highlightRight__yGn1J","highlightLeft":"style-module_highlightLeft__WLjC0"};

const Overlap = ({ id = "overlap", ImageComponent, highlightLeft = false, children, fullWidth, className, background, }) => {
    const theme = React.useContext(ThemeContext);
    const contentInverted = theme === "white" || (theme === "gray" && fullWidth);
    const contentTheme = contentInverted ? "primary" : "white";
    return (React.createElement("div", { className: classNames(style$k.wrapper, {
            [style$k.fullWidth]: fullWidth,
            [style$k.highlightLeft]: highlightLeft,
            [style$k.highlightRight]: !highlightLeft,
        }, className), id: `${id}-wrapper` },
        React.createElement("div", { className: style$k.image, id: `${id}-image-wrapper` }, ImageComponent),
        React.createElement(ThemeContext.Provider, { value: background ? "primary" : contentTheme },
            React.createElement("div", { className: classNames(style$k.content, background && style$k[camelcase(background)], {
                    [style$k.fullWidth]: fullWidth,
                    [style$k.inverted]: contentInverted,
                }), id: `${id}-content` }, children))));
};

var style$j = {"podcast":"style-module_podcast__e42-b","iframe":"style-module_iframe__IVEgO","info":"style-module_info__8FhrC","icon":"style-module_icon__jgLrz","title":"style-module_title__HpN9-","description":"style-module_description__cbDOL"};

const Podcast = ({ title, description, podcastId, color }) => {
    const primaryColor = color ||
        getComputedStyle(document.body)
            .getPropertyValue("--theme-primary")
            .replace("#", "")
            .trim();
    return (React.createElement("div", { className: style$j.podcast },
        React.createElement("div", null,
            React.createElement("iframe", { className: style$j.iframe, frameBorder: "0", id: "ausha-rHOw", loading: "lazy", src: `https://player.ausha.co/index.html?podcastId=${podcastId}&playerId=ausha-rHOw&color=%23${primaryColor}` }),
            React.createElement("script", { src: "https://player.ausha.co/ausha-player.js" })),
        title && description && (React.createElement("div", { className: style$j.info },
            React.createElement("div", { className: style$j.title },
                React.createElement(Icon, { className: style$j.icon, name: "play", size: 22 }),
                title),
            React.createElement("div", { className: style$j.description }, description)))));
};

const Portal = ({ children }) => {
    const portalRoot = typeof document !== "undefined"
        ? document.getElementsByTagName("body")[0]
        : null;
    return portalRoot ? ReactDOM.createPortal(children, portalRoot) : null;
};

var style$i = {"quote":"style-module_quote__9qAmQ","content":"style-module_content__-zOrh","big":"style-module_big__V0Kyw","small":"style-module_small__ORMAY","author":"style-module_author__W37S9","name":"style-module_name__6KHh-","info":"style-module_info__lJcPq","inverted":"style-module_inverted__A5E8u"};

const Quote = ({ content, author, additionalAuthorInfo, variant = "big", }) => {
    const theme = useContext(ThemeContext);
    const inverted = theme === "primary";
    const isDesktop = useMediaQuery();
    const getIconSize = () => {
        if (variant === "big") {
            return isDesktop ? 67 : 59;
        }
        return isDesktop ? 40 : 30;
    };
    return (React.createElement("div", { className: classNames(style$i.quote, inverted && style$i.inverted) },
        React.createElement("blockquote", { className: classNames(style$i.content, style$i[variant]) },
            React.createElement(Icon, { className: style$i.icon, name: "quote", size: getIconSize() }),
            React.createElement("span", null, content)),
        React.createElement("div", { className: style$i.author },
            React.createElement("span", { className: style$i.name }, author),
            React.createElement("span", { className: style$i.info }, additionalAuthorInfo))));
};

var style$h = {"reportHighlight":"style-module_reportHighlight__aDRtK","spacer":"style-module_spacer__SBkI1","inner":"style-module_inner__iT3iv","image":"style-module_image__BJmtE","content":"style-module_content__CJWlF","linkWrapper":"style-module_linkWrapper__aj3M4","ctaText":"style-module_ctaText__-BNtb"};

const ReportHighlight = ({ image, title, cta }) => {
    const content = (React.createElement("div", { className: style$h.inner },
        React.createElement("div", { className: style$h.image }, image),
        React.createElement("div", { className: style$h.content },
            React.createElement(ThemeContext.Provider, { value: "primary" },
                React.createElement(Typography, { className: style$h.title, removeMargin: true, variant: "h4" },
                    React.createElement("b", null, title)),
                cta && (React.createElement(Typography, { className: style$h.ctaText }, cta.props.children))))));
    return (React.createElement("div", { className: style$h.reportHighlight },
        React.createElement("div", { className: style$h.spacer }, cta ? (React.createElement(Link, { className: style$h.linkWrapper, destination: cta.props.href }, content)) : (content))));
};

var style$g = {"visiblyHidden":"style-module_visiblyHidden__Tdz3N","searchAndFilter":"style-module_searchAndFilter__Syi9z","title":"style-module_title__nJoy1","queryWrapper":"style-module_queryWrapper__qgvtG","searchIcon":"style-module_searchIcon__6q8Pn","queryInput":"style-module_queryInput__GOojQ","resetButton":"style-module_resetButton__Bvn6x","select":"style-module_select__uoGzk"};

const SearchAndFilter = ({ title, options, onCategoryChange, onQueryChange, queryPlaceholder = "Search documents...", queryLabel = "Search documents by title or description", resetQueryLabel = "Clear search query", dropdownLabel = "Filter documents by category", showDropdown = true, }) => {
    const inputRef = useRef(null);
    const [query, setQuery] = useState("");
    const [category, setCategory] = useState("");
    const handleQueryChange = (ev) => {
        setQuery(ev.target.value);
        onQueryChange(ev.target.value);
    };
    const handleDropdownChange = (value) => {
        const newValue = value !== category ? value : "";
        setCategory(newValue);
        onCategoryChange(newValue);
    };
    const resetQuery = () => {
        setQuery("");
        onQueryChange("");
    };
    const focusOnInput = () => {
        inputRef.current && inputRef.current.focus();
    };
    return (React.createElement("div", { className: style$g.searchAndFilter },
        React.createElement(Typography, { className: style$g.title, variant: "subtitle-small" }, title),
        showDropdown && (React.createElement(React.Fragment, null,
            React.createElement("label", { className: style$g.visiblyHidden, htmlFor: "searchAndFilter-category-dropdown-trigger", id: "searchAndFilter-category-label" }, dropdownLabel),
            React.createElement(Select, { className: style$g.select, floatingOptions: true, id: "searchAndFilter-category-dropdown", items: options, labelId: "searchAndFilter-category-label", noBoldStyling: true, onChange: handleDropdownChange, value: category }))),
        React.createElement("div", { className: style$g.queryWrapper, onClick: focusOnInput },
            React.createElement(Icon, { className: style$g.searchIcon, color: "darkGrey", name: "searchSimple", size: 20 }),
            React.createElement("label", { className: style$g.visiblyHidden, htmlFor: "searchAndFilter-query-input" }, queryLabel),
            React.createElement(Input, { className: style$g.queryInput, id: "searchAndFilter-query-input", onChange: handleQueryChange, placeholder: queryPlaceholder, ref: inputRef, type: "search", value: query }),
            !!query && (React.createElement(Button, { "aria-label": resetQueryLabel, className: style$g.resetButton, iconName: "close", iconSize: 25, name: resetQueryLabel, onClick: resetQuery, variant: "icon" })))));
};

var style$f = {"searchBar":"style-module_searchBar__cuy0P","scrolled":"style-module_scrolled__4MGM8","open":"style-module_open__YHyFq","collapse":"style-module_collapse__3fX5W","visiblyHidden":"style-module_visiblyHidden__PFWMD","input":"style-module_input__NX9jV","button":"style-module_button__SNTNL","closeButton":"style-module_closeButton__xDtZa"};

const SearchBar = ({ isOpen, onSearch, onClose, placeholder = "Enter your search here...", label = "Search input", closeButtonLabel = "Close search", searchButtonLabel = "Start search", scrolled, }) => {
    const [query, setQuery] = useState("");
    const formRef = useRef(null);
    function handleSubmit(ev) {
        ev.preventDefault();
        onSearch(query);
        setQuery("");
        return false;
    }
    const handleClose = useCallback(() => {
        var _a;
        setQuery("");
        onClose();
        (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur();
    }, [onClose]);
    useEffect(() => {
        var _a, _b;
        if (!isOpen) {
            setQuery("");
        }
        else
            (_b = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("#search-input")) === null || _b === void 0 ? void 0 : _b.focus();
    }, [isOpen]);
    const handleEscape = (ev) => {
        if (ev.key.toLowerCase() === "escape" ||
            ev.which === 27 ||
            ev.keyCode === 27) {
            ev.preventDefault();
            handleClose();
        }
    };
    return (React.createElement("form", { "aria-hidden": !isOpen, className: classNames(style$f.searchBar, {
            [style$f.open]: isOpen,
            [style$f.scrolled]: scrolled,
        }), id: "searchBox", onKeyDown: handleEscape, ref: formRef },
        React.createElement("label", { className: style$f.visiblyHidden, htmlFor: "search-input" }, label),
        React.createElement(Button, { "aria-hidden": !isOpen, "aria-label": closeButtonLabel, className: style$f.closeButton, iconColor: "primary", iconName: "close", iconSize: 25, name: closeButtonLabel, onClick: handleClose, tabindex: isOpen ? 0 : -1, type: "button", variant: "icon" }),
        React.createElement("input", { "aria-hidden": !isOpen, className: style$f.input, id: "search-input", name: "searchInput", onChange: ev => setQuery(ev.target.value), placeholder: placeholder, tabIndex: isOpen ? 0 : -1, type: "search", value: query }),
        React.createElement(Button, { "aria-hidden": !isOpen, "aria-label": searchButtonLabel, className: style$f.button, iconColor: "primary", iconName: "search", iconSize: 30, name: searchButtonLabel, onClick: handleSubmit, tabindex: isOpen ? 0 : -1, type: "submit", variant: "icon" })));
};

var style$e = {"searchResult":"style-module_searchResult__kLfl1","title":"style-module_title__ZWkMM","description":"style-module_description__4095T","link":"style-module_link__S74XE"};

const SearchResult = ({ title, description, LinkComponent, destination, linkText, isDocument, }) => (React.createElement("article", { className: style$e.searchResult },
    React.createElement(Typography, { className: style$e.title, removeMargin: true, variant: "search-title" }, title),
    description && (React.createElement(Typography, { className: style$e.description, variant: "para" }, description)),
    isDocument ? (React.createElement("a", { href: destination, rel: "noopener noreferrer", target: "_blank" },
        React.createElement(Typography, { className: style$e.link, color: "primary", removeMargin: true, variant: "para" }, linkText))) : (React.createElement(Link, { Component: LinkComponent, destination: destination },
        React.createElement(Typography, { className: style$e.link, color: "primary", removeMargin: true, variant: "para" }, linkText)))));

var style$d = {"titleAndDescription":"style-module_titleAndDescription__W3kGM","noDescription":"style-module_noDescription__AZpn5","padding":"style-module_padding__ke2UA","description":"style-module_description__laiLn","alignCenter":"style-module_alignCenter__PZnqp","alignRight":"style-module_alignRight__6DGWc"};

const TitleAndDescription = ({ title, description, fullWidth = false, parentHasNoPadding = false, }) => {
    const titleDivider = !!title && !!description;
    const alignment = useContext(AlignmentContext);
    return (React.createElement(Container, { className: classNames(style$d.titleAndDescription, alignment && style$d[`align${alignment}`], !description && style$d.noDescription, parentHasNoPadding && fullWidth && style$d.padding), fluid: fullWidth ? "md" : true },
        title &&
            React.cloneElement(title, {
                options: {
                    ...title.props.options,
                    underline: alignment !== "Center" && titleDivider,
                },
            }),
        description &&
            React.cloneElement(description, {
                className: style$d.description,
            })));
};

var style$c = {"wrapper":"style-module_wrapper__JR6gL","spacingTopSmall":"style-module_spacingTopSmall__h1hVA","spacingBottomSmall":"style-module_spacingBottomSmall__JwnBB","spacingTopMedium":"style-module_spacingTopMedium__hPoyJ","spacingBottomMedium":"style-module_spacingBottomMedium__7X8q9","spacingTopLarge":"style-module_spacingTopLarge__Us-v1","spacingBottomLarge":"style-module_spacingBottomLarge__kFCgH","withBorder":"style-module_withBorder__uiZ0b","fullWidth":"style-module_fullWidth__pislh","noPadding":"style-module_noPadding__43LAV","additionalCta":"style-module_additionalCta__12Jn7","backLink":"style-module_backLink__5j0bX","primary":"style-module_primary__1mK-Y","trustedBlue":"style-module_trustedBlue__grWjI","withSidebar":"style-module_withSidebar__frjCp","withBackLink":"style-module_withBackLink__kyl-2","content":"style-module_content__aPasJ","white":"style-module_white__GQkFd","gray":"style-module_gray__QeOKf","alignCenter":"style-module_alignCenter__zENZ3","alignRight":"style-module_alignRight__rXwKw"};

const Section = ({ additionalCta, anchorLink, background = "white", backLink, bottomSpacing, children, className, contentAlignment = "Left", description, fullWidth, id = "Section", IntroText, noPadding, sidebar, title, topSpacing, withBorder, }, ref) => {
    var _a, _b, _c, _d;
    return (React.createElement("section", { className: classNames(style$c.wrapper, style$c[background], style$c[`spacingTop${topSpacing || "Medium"}`], style$c[`spacingBottom${bottomSpacing || "Medium"}`], !!contentAlignment && style$c[`align${contentAlignment}`], {
            [style$c.fullWidth]: fullWidth,
            [style$c.withBorder]: withBorder,
            [style$c.noPadding]: noPadding,
        }, className), id: anchorLink, ref: ref },
        React.createElement(ThemeContext.Provider, { value: background },
            React.createElement(AlignmentContext.Provider, { value: contentAlignment },
                React.createElement(Container, { className: classNames("px-0", {
                        [style$c.withSidebar]: sidebar,
                        [style$c.withBackLink]: backLink,
                    }), fluid: fullWidth ? true : "md", id: id },
                    backLink &&
                        cloneElement(backLink, {
                            ...((backLink === null || backLink === void 0 ? void 0 : backLink.props) || {}),
                            className: classNames((_a = backLink === null || backLink === void 0 ? void 0 : backLink.props) === null || _a === void 0 ? void 0 : _a.className, style$c.backLink, style$c[background]),
                        }),
                    sidebar,
                    React.createElement("div", { className: style$c.content },
                        title || description ? (React.createElement(TitleAndDescription, { description: description, fullWidth: fullWidth, parentHasNoPadding: noPadding, title: title })) : null,
                        IntroText &&
                            cloneElement(IntroText, {
                                options: {
                                    ...(((_b = IntroText === null || IntroText === void 0 ? void 0 : IntroText.props) === null || _b === void 0 ? void 0 : _b.options) || {}),
                                    color: background === "trustedBlue"
                                        ? "white"
                                        : (_d = (_c = IntroText === null || IntroText === void 0 ? void 0 : IntroText.props) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.color,
                                    variant: "para-article-intro",
                                },
                            }),
                        children,
                        additionalCta && (React.createElement("div", { className: style$c.additionalCta }, additionalCta))))))));
};
var index = forwardRef(Section);

var style$b = {"serviceCard":"style-module_serviceCard__x7QWH","title":"style-module_title__pYU3-"};

const ServiceCard = ({ icon, title, description }) => (React.createElement("div", { className: style$b.serviceCard },
    React.createElement("div", { className: style$b.icon },
        React.createElement(Icon, { color: "darkGrey", name: icon, size: 44 })),
    React.createElement(Typography, { className: style$b.title }, title),
    React.createElement("div", { className: style$b.description }, description)));

var style$a = {"wrapper":"style-module_wrapper__WxrXf","image":"style-module_image__3LBeJ","content":"style-module_content__uSu9W","mobileHidden":"style-module_mobileHidden__B9stz","date":"style-module_date__iJYqI","noImage":"style-module_noImage__a-KRD"};

const SimpleNewsCard = ({ image, publishDate, title, hideContentMobile, }) => (React.createElement("div", { className: classNames(style$a.wrapper, { [style$a.noImage]: !image }) },
    image && React.createElement("div", { className: style$a.image }, image),
    React.createElement("div", { className: classNames(style$a.content, {
            [style$a.mobileHidden]: hideContentMobile,
        }) },
        React.createElement(Typography, { className: style$a.date, removeMargin: true, variant: "h6" }, publishDate),
        title)));

const isDefined = (thing) => thing !== undefined && thing !== null;
const objectToParams = (object) => {
    const params = Object.entries(object)
        .filter(([, value]) => isDefined(value))
        .map(([key, value]) => encodeURIComponent(key) +
        "=" +
        encodeURIComponent(String(value)));
    return params.length === 0 ? "" : "?" + params.join("&");
};

const TWITTER_URL = "https://twitter.com/intent/tweet";
const createTwitterLink = (data) => {
    if (data.hashtags && !Array.isArray(data.hashtags))
        throw new Error("hashtags is not an array of strings");
    if (data.via && !Array.isArray(data.via))
        throw new TypeError("via is not an array of strings");
    const urlParams = objectToParams(data);
    return TWITTER_URL + urlParams;
};
const createMailtoLInk = ({ subject, body }) => "mailto: " + objectToParams({ subject, body });
const LINKEDIN_URL = "https://linkedin.com/cws/share";
const createLinkedinLink = (data) => LINKEDIN_URL + objectToParams({ ...data, mini: true });
const createLinkForSocial = (social, data) => {
    switch (social) {
        case "mail": {
            const { emailSubject: subject, shareText: body } = data;
            return createMailtoLInk({ subject, body });
        }
        case "twitter": {
            const { url, twitterHashtags: hashtags, twitterRelated: via, shareText: text, } = data;
            return createTwitterLink({ url, hashtags, via, text });
        }
        case "linkedin": {
            const { url, linkedinTitle: title, shareText: summary, linkedinSource: source, } = data;
            return createLinkedinLink({ url, title, summary, source });
        }
        default:
            return "";
    }
};

var style$9 = {"button":"style-module_button__4o-h8","inverted":"style-module_inverted__00qEM"};

const SocialButton = ({ id, variant = "default", social, pageUrl, className, ariaLabel, ...rest }) => {
    const theme = React.useContext(ThemeContext);
    variant = theme === "primary" ? "inverted" : variant;
    if (!pageUrl)
        return null;
    const url = createLinkForSocial(social, {
        ...rest,
        url: social !== "mail" ? pageUrl : undefined,
    });
    return (React.createElement("a", { "aria-label": ariaLabel, className: classNames(style$9.button, style$9[variant], className), href: url, id: id, rel: "noopener noreferrer", target: "_blank" },
        React.createElement(Icon, { name: social, size: 25 })));
};

var style$8 = {"splitSection":"style-module_splitSection__RB0GR","inner":"style-module_inner__HHaSb","divider":"style-module_divider__LZCiy","hidden":"style-module_hidden__SX6C7","leftContent":"style-module_leftContent__-mwek","rightContent":"style-module_rightContent__r4Bsh","fullWidth":"style-module_fullWidth__lFoMu","containsOnlyRichText":"style-module_containsOnlyRichText__NOpcn","primary":"style-module_primary__u3e0P","distr6040":"style-module_distr6040__TbvbW","distr4060":"style-module_distr4060__ptupa"};

const SplitSection = ({ firstChild, secondChild, hideDivider, reverseOrder, distribution = "50-50", fullWidth, containsOnlyRichText, }) => {
    const theme = React.useContext(ThemeContext);
    const distributionClass = distribution.replace("-", "");
    return (React.createElement("section", { className: classNames(style$8.splitSection, style$8[theme], style$8[`distr${distributionClass}`]) },
        React.createElement("div", { className: classNames(style$8.inner, fullWidth && style$8.fullWidth, containsOnlyRichText && style$8.containsOnlyRichText) },
            React.createElement("section", { className: style$8.leftContent }, reverseOrder ? secondChild : firstChild),
            (!fullWidth || containsOnlyRichText) && (React.createElement("div", { className: classNames(style$8.divider, hideDivider && style$8.hidden) })),
            React.createElement("section", { className: style$8.rightContent }, reverseOrder ? firstChild : secondChild))));
};

var style$7 = {"wrapper":"style-module_wrapper__DjnTa","image":"style-module_image__bdHCB","content":"style-module_content__KlnFh","inverted":"style-module_inverted__43fO3","stretch":"style-module_stretch__VyWFB"};

const SubAssetCard = ({ id = "SubAssetCard", ImageComponent, children, className, stretch, }) => {
    const sectionTheme = React.useContext(ThemeContext);
    const cardTheme = sectionTheme === "white" ? "primary" : "white";
    return (React.createElement("div", { className: classNames(style$7.wrapper, {
            [style$7.stretch]: stretch,
        }, className), id: `${id}-wrapper` },
        React.createElement("div", { className: style$7.image, id: `${id}-image-wrapper` }, ImageComponent),
        React.createElement("div", { className: classNames(style$7.content, {
                [style$7.inverted]: sectionTheme === "white",
                [style$7.stretch]: stretch,
            }), id: `${id}-content` },
            React.createElement(ThemeContext.Provider, { value: cardTheme }, children))));
};

var style$6 = {"tabs":"style-module_tabs__K1hYN","row":"style-module_row__XdSph","tab":"style-module_tab__1ItZg","button":"style-module_button__bPG--","title":"style-module_title__lWZQq","active":"style-module_active__VpSF1","white":"style-module_white__Icb8d","darkGrey":"style-module_darkGrey__keYpl","primary":"style-module_primary__0R6IQ","midGrey":"style-module_midGrey__LzT0o","lightGrey":"style-module_lightGrey__G5fWM","lightMidGrey":"style-module_lightMidGrey__-JID-","primaryGreen":"style-module_primaryGreen__DO5ye","sustainableGreen":"style-module_sustainableGreen__C2kHz","fundamentalGreen":"style-module_fundamentalGreen__2A7xA","multiBlue":"style-module_multiBlue__L627E","fixedBlue":"style-module_fixedBlue__DSAQj","quantitativeRed":"style-module_quantitativeRed__GUZbG","trustedBlue":"style-module_trustedBlue__a2ybS","error":"style-module_error__L0Fbb","main":"style-module_main__pORdX","buttonWrapper":"style-module_buttonWrapper__Q6vB2","content":"style-module_content__J0vwX","singleTab":"style-module_singleTab__ot1v5","twoTabs":"style-module_twoTabs__SA7QE","threeTabs":"style-module_threeTabs__g-QWe"};

const Tabs = ({ tabs }) => {
    const [activeTab, setActiveTab] = useState(0);
    return (React.createElement("div", { className: style$6.tabs },
        React.createElement(Row, { className: style$6.row }, tabs.map((tab, index) => (React.createElement(Col, { className: style$6.tab, key: `tab-title-${tab.id || index}`, lg: 3, xs: 4 },
            React.createElement("div", { className: classNames(style$6.buttonWrapper, tab.theme && style$6[camelcase(tab.theme)], activeTab === index && style$6.active) },
                React.createElement("button", { className: classNames(style$6.button, tab.theme && style$6[camelcase(tab.theme)], activeTab === index && style$6.active), onClick: () => setActiveTab(index), onFocus: () => setActiveTab(index), onMouseOver: () => setActiveTab(index) }, React.cloneElement(tab.title, {
                    className: style$6.title,
                    options: {
                        inline: true,
                        removeMargin: true,
                    },
                }))))))),
        React.createElement("div", { className: classNames(style$6.content, {
                [style$6.singleTab]: (tabs === null || tabs === void 0 ? void 0 : tabs.length) === 1,
                [style$6.twoTabs]: (tabs === null || tabs === void 0 ? void 0 : tabs.length) === 2,
                [style$6.threeTabs]: (tabs === null || tabs === void 0 ? void 0 : tabs.length) === 3,
            }) },
            React.createElement(Fade, null, tabs[activeTab].content))));
};

var style$5 = {"thumbnailLink":"style-module_thumbnailLink__Qto-g","image":"style-module_image__i0yWA","label":"style-module_label__0CCUP"};

const ThumbnailLink = ({ thumbnail, children, destination, linkComponent: LinkComponent, className, }) => (React.createElement(Link, { Component: LinkComponent, className: style$5.thumbnailLink, destination: destination },
    React.createElement("div", { className: style$5.image }, thumbnail),
    React.createElement("div", { className: classNames(style$5.label, className) }, children)));

var style$4 = {"timelineItem":"style-module_timelineItem__sDO-i","image":"style-module_image__4kimJ","content":"style-module_content__VXm4e","annotation":"style-module_annotation__Ve0Eb","withImage":"style-module_withImage__zKZ-A","primary":"style-module_primary__798Y0","gray":"style-module_gray__EaZQV","highlighted":"style-module_highlighted__ILyNW","bigNotation":"style-module_bigNotation__Cl892","alignRight":"style-module_alignRight__JcNUe"};

const TimelineItem = ({ content, image, annotation, highlighted = false, mirrored = false, className, theme = "white", }) => {
    const highlight = highlighted && theme !== "primary";
    const bigNotation = annotation.toString().length < 3;
    return (React.createElement("div", { className: classNames(className, style$4.timelineItem, {
            [style$4.highlighted]: highlighted,
            [style$4[theme]]: theme,
        }) },
        image && React.cloneElement(image, { className: style$4.image }),
        React.createElement("div", { className: classNames(style$4.content, {
                [style$4.withImage]: image,
                [style$4.alignRight]: mirrored,
                [style$4.bigNotation]: bigNotation,
            }) },
            React.createElement(Typography, { className: style$4.annotation, color: highlight ? "primary" : "white", variant: "h4" }, annotation),
            React.cloneElement(content, {
                options: {
                    color: highlight ? "white" : "darkGrey",
                },
            }))));
};

var style$3 = {"timeline":"style-module_timeline__Gf36O","line":"style-module_line__vJFYl","innerContent":"style-module_innerContent__COetd","moment":"style-module_moment__LiT-B","controls":"style-module_controls__L1EnH","button":"style-module_button__sCpFT","icon":"style-module_icon__RHTxY","arrowDown":"style-module_arrowDown__jJp6L","arrowUp":"style-module_arrowUp__p4z1B","outlined":"style-module_outlined__BsGDR","interactive":"style-module_interactive__YAJ7C","primary":"style-module_primary__P-yKM"};

var Direction;
(function (Direction) {
    Direction[Direction["OLDER"] = -1] = "OLDER";
    Direction[Direction["NEWER"] = 1] = "NEWER";
})(Direction || (Direction = {}));
const VARIATION = {
    SIMPLE: "Simple",
    INTERACTIVE: "Interactive",
};
const px2rem = (size) => size / 16;
const getHeights = (...wrappers) => wrappers.map(wrapper => wrapper && wrapper.current ? wrapper.current.offsetHeight : 0);
const getYPositions = (outerWrapper, innerWrapper, moments) => {
    const [outerH, innerH] = getHeights(outerWrapper, innerWrapper);
    const positions = [0];
    const offsetFromTopScreen = 35;
    const lastPosition = innerH - outerH;
    let top = 0;
    let bottom = outerH;
    while (bottom < innerH) {
        const lastMoment = getLastMomentOnscreen(moments, {
            top,
            bottom,
        });
        if (lastMoment)
            top = lastMoment.offsetTop - offsetFromTopScreen;
        else
            top = bottom + offsetFromTopScreen;
        if (top < lastPosition)
            positions.push(top);
        bottom = top + outerH;
    }
    positions.push(lastPosition);
    return [positions, positions.length - 1];
};
const getLastMomentOnscreen = (moments, screen) => moments.find(moment => {
    if (!moment)
        return;
    const top = moment.offsetTop;
    const h = moment.offsetHeight;
    const bottom = top + h;
    return top > screen.top && bottom > screen.bottom;
});
const Timeline = ({ content, controlsOpt, variation = VARIATION.SIMPLE, }) => {
    const breakpoint = 950;
    const [isInteractive, setIsInteractive] = useState(false);
    const backgroundTheme = React.useContext(ThemeContext);
    const outerTimelineWrapper = useRef(null);
    const innertimelineWrapper = useRef(null);
    const moments = useRef([]);
    const allSteps = useRef([]);
    const currentStep = useRef(0);
    const onDesktop = useMediaQuery(breakpoint);
    const [yPosition, setYPosition] = useState(0);
    const [disableOlderBtn, setDisableOlderBtn] = useState(true);
    const [disableNewerBtn, setDisableNewerBtn] = useState(false);
    const [offsets, setOffsets] = useState([]);
    const moveTimeline = (dir) => {
        const stepInd = currentStep.current + dir;
        const [steps, totalSteps] = getYPositions(outerTimelineWrapper, innertimelineWrapper, moments.current);
        allSteps.current = steps;
        currentStep.current = stepInd;
        setDisableOlderBtn(currentStep.current === 0);
        setDisableNewerBtn(currentStep.current === totalSteps);
        setYPosition(allSteps.current[stepInd]);
    };
    useEffect(() => {
        let _isInteractive = false;
        if (onDesktop && variation === VARIATION.INTERACTIVE)
            _isInteractive = true;
        if (!onDesktop)
            currentStep.current = 0;
        setYPosition(pos => (!onDesktop ? 0 : pos));
        setIsInteractive(_isInteractive);
    }, [onDesktop]);
    useEffect(() => {
        if (!moments.current.length)
            return;
        const _offsets = moments.current.map((moment, index) => {
            const hasImage = (i) => { var _a; return !!((_a = content === null || content === void 0 ? void 0 : content[i]) === null || _a === void 0 ? void 0 : _a.image); };
            const getOffsetMargin = () => {
                if (index === 0)
                    return 0;
                if (moment && hasImage(index)) {
                    if (hasImage(index - 1))
                        return -175;
                    return -100;
                }
                return 25;
            };
            return {
                offsetMargin: getOffsetMargin(),
            };
        });
        setOffsets(_offsets);
    }, [onDesktop]);
    return (React.createElement("div", { className: classNames(style$3.timeline, {
            [style$3.interactive]: isInteractive,
            [style$3[backgroundTheme]]: backgroundTheme,
        }), ref: outerTimelineWrapper },
        React.createElement("div", { className: style$3.innerContent, ref: innertimelineWrapper, style: { transform: `translate(0, -${px2rem(yPosition)}rem)` } }, content === null || content === void 0 ? void 0 : content.map((item, i) => {
            var _a;
            return (React.createElement("div", { className: style$3.moment, key: i, 
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                ref: el => (moments.current[i] = el), style: onDesktop
                    ? {
                        marginTop: `${px2rem((_a = offsets[i]) === null || _a === void 0 ? void 0 : _a.offsetMargin)}rem`,
                    }
                    : undefined },
                React.createElement(TimelineItem, { ...item, className: style$3.content, mirrored: i % 2 !== 0, theme: backgroundTheme })));
        })),
        React.createElement("span", { className: style$3.line }),
        isInteractive && controlsOpt && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: style$3.controls },
                React.createElement(Button, { className: classNames(style$3.button, style$3.outlined), disabled: disableOlderBtn, onClick: () => moveTimeline(Direction.OLDER), variant: "outlined" },
                    controlsOpt.olderBtnText,
                    React.createElement(Icon, { className: classNames(style$3.icon, style$3.arrowUp), name: "arrowUp" })),
                React.createElement(Button, { className: style$3.button, disabled: disableNewerBtn, onClick: () => moveTimeline(Direction.NEWER) },
                    controlsOpt.newerBtnText,
                    React.createElement(Icon, { className: classNames(style$3.icon, style$3.arrowDown), name: "arrowUp" })))))));
};

var style$2 = {"value":"style-module_value__P1Oef","wrapper":"style-module_wrapper__UAud0","valuesCard":"style-module_valuesCard__duPdl","image":"style-module_image__7XdUT","caption":"style-module_caption__9vSj-","background":"style-module_background__F47Tc","content":"style-module_content__5LN4X","mobileHidden":"style-module_mobileHidden__vxO6N"};

const ValuesCard = ({ caption, value, image, hideContentMobile, destination, }) => {
    const CardContent = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: style$2.valuesCard, tabIndex: 0 },
            React.createElement("div", { className: style$2.image }, image),
            caption && (React.createElement("div", { className: style$2.caption },
                React.createElement("div", { className: style$2.background }),
                React.createElement("div", { className: classNames(style$2.content, {
                        [style$2.mobileHidden]: hideContentMobile,
                    }) }, caption)))),
        React.createElement("div", { className: style$2.value }, value)));
    return destination ? (React.createElement(Link, { className: style$2.wrapper, destination: destination }, CardContent)) : (React.createElement("div", { className: style$2.wrapper }, CardContent));
};

var style$1 = {"video":"style-module_video__Jajf-","variableHeight":"style-module_variableHeight__9QUPr","image":"style-module_image__qrZfN","playButton":"style-module_playButton__EXF1O","icon":"style-module_icon__ER7xA","center":"style-module_center__uxzeM","bottomLeft":"style-module_bottomLeft__6Gq8M","modal":"style-module_modal__w6g7i","background":"style-module_background__4RJUY","closeBtn":"style-module_closeBtn__4DueS","videoWrapper":"style-module_videoWrapper__CDBE3"};

const PlayButton = ({ position }) => (React.createElement("div", { className: classNames(style$1.playButton, style$1[position]) },
    React.createElement(Icon, { className: style$1.icon, color: "white", name: "play", size: 39 })));
const VideoModal = ({ id, unlistedHash, onClose }) => {
    const src = new URL(`https://player.vimeo.com/video/${id}?autoplay=1&title=0&byline=0&portrait=0`);
    unlistedHash && src.searchParams.append("h", unlistedHash);
    return (React.createElement(Portal, null,
        React.createElement("div", { className: style$1.modal },
            React.createElement("div", { className: style$1.background, onClick: onClose }),
            React.createElement("div", { "aria-label": "close button", className: style$1.closeBtn, onClick: onClose, role: "button" },
                React.createElement(Icon, { color: "white", name: "close", size: 40 })),
            React.createElement("div", { className: style$1.videoWrapper },
                React.createElement("iframe", { allow: "autoplay", allowFullScreen: true, frameBorder: "0", src: src.toString() })))));
};
const Video = ({ videoId, unlistedHash, thumbnail, buttonPosition = "center", className, variableHeight, }) => {
    const [open, setOpen] = useState(false);
    const [fallbackThumbnail, setFallbackThumbnail] = useState();
    const toggleModal = (state) => setOpen(state);
    useEffect(() => {
        const embedUrl = new URL(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}/${unlistedHash}`);
        const getVideoData = async (url) => {
            try {
                const response = await fetch(url);
                const data = await response.json();
                setFallbackThumbnail({
                    src: data.thumbnail_url,
                    alt: data.description,
                });
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        };
        getVideoData(embedUrl.toString());
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(style$1.video, className, {
                [style$1.variableHeight]: variableHeight,
            }), onClick: () => toggleModal(true) },
            React.createElement("div", { className: style$1.image }, thumbnail !== null && thumbnail !== void 0 ? thumbnail : React.createElement("img", { ...fallbackThumbnail })),
            React.createElement(PlayButton, { position: buttonPosition })),
        open && (React.createElement(VideoModal, { id: videoId, onClose: () => toggleModal(false), unlistedHash: unlistedHash }))));
};

var style = {"arrowGuide":"style-module_arrowGuide__d5-GD","arrow":"style-module_arrow__iYavK","arrow-main":"style-module_arrow-main__5p8g-","arrow-secondary":"style-module_arrow-secondary__Vu7Ea","themeClearGreen":"style-module_themeClearGreen__M4OcP","themeLightGreen":"style-module_themeLightGreen__wO498","themeDarkGreen":"style-module_themeDarkGreen__5mNCD","themeLightBlue":"style-module_themeLightBlue__zJoCc","themeDarkBlue":"style-module_themeDarkBlue__Io36w","themeDarkRed":"style-module_themeDarkRed__CAkOl","themeTrustedBlue":"style-module_themeTrustedBlue__0E-qL","themeMain":"style-module_themeMain__UWTg0","main":"style-module_main__9J49J","secondary":"style-module_secondary__3BEob"};

/**
 * Props for the ArrowGuide component.
 * @typedef {Object} Props
 * @property {string} content - The content of the arrow guide.
 * @property {string} arrow - The arrow direction.
 * @property {string} variant - The variant of the arrow guide.
 * @property {() => void} onClick - Function to handle the click event.
 */
const ArrowGuide = ({ content, arrow = "arrowLeft", variant = "main", onClick, }) => (React.createElement("button", { className: `${style.arrowGuide} ${style[variant]}`, onClick: onClick },
    React.createElement(Icon, { className: style.arrow, color: variant === "main" ? "main" : "sustainableGreen", name: arrow }),
    content));

export { AlignmentContext, AngleCard, ArrowGuide, Author, BackLink, BrandCard, Button, CTA, CTARound, CallToAction, CardIcon, Carousel, CarouselBody, CarouselButton, CategoryRow, Columns, CompareFunds, ContactPoint, CountryBlock, CountryDetailBlock, CountryList, CtaOverlayContent, DeprecatedCarouselButton as DEPRECATED_CarouselButton, Divider, Document, FaqCollection, FaqItem, FeaturedCard, Flag, Footer, Hamburger, Hero, HeroCarousel, HighlightedArticle, HrInfoCard, Icon, IconNumberCard, IconWithTooltip, ImageSectionWithOverlay, Input, Jobcard, Label, LatestArticlesSection, Link, List, ListViewToggle, MainNavigation, MediaGrid, MenuThemeContext, MobileMenu, Modal, ModalImage, NavigationMinorActions, NavigationPrimaryActions, NewsCard, NumberCard, Overlap, Podcast, Portal, Quote, ReportHighlight, SearchAndFilter, SearchBar, SearchResult, index as Section, Select, ServiceCard, SimpleNewsCard, SocialButton, SplitSection, SubAssetCard, SubNavigation, Tabs, ThemeContext, ThumbnailLink, Timeline, TimelineItem, TitleAndDescription, Typography, ValuesCard, Video };
//# sourceMappingURL=index.js.map
